// @__NO_SIDE_EFFECTS__
function Kr(e) {
  return {
    lang: (e == null ? void 0 : e.lang) ?? void 0,
    message: e == null ? void 0 : e.message,
    abortEarly: (e == null ? void 0 : e.abortEarly) ?? void 0,
    abortPipeEarly: (e == null ? void 0 : e.abortPipeEarly) ?? void 0
  };
}
// @__NO_SIDE_EFFECTS__
function ja(e, t) {
  var n;
  return (n = void 0) == null ? void 0 : n.get(t);
}
// @__NO_SIDE_EFFECTS__
function qa(e) {
  var t, n;
  const r = typeof e;
  return r === "string" ? `"${e}"` : r === "number" || r === "bigint" || r === "boolean" ? `${e}` : r === "object" || r === "function" ? (e && ((n = (t = Object.getPrototypeOf(e)) == null ? void 0 : t.constructor) == null ? void 0 : n.name)) ?? "null" : r;
}
function ve(e, t, n, r, s) {
  const o = s && "input" in s ? s.input : n.value, a = (s == null ? void 0 : s.expected) ?? e.expects ?? null, i = (s == null ? void 0 : s.received) ?? /* @__PURE__ */ qa(o), u = {
    kind: e.kind,
    type: e.type,
    input: o,
    expected: a,
    received: i,
    message: `Invalid ${t}: ${a ? `Expected ${a} but r` : "R"}eceived ${i}`,
    requirement: e.requirement,
    path: s == null ? void 0 : s.path,
    issues: s == null ? void 0 : s.issues,
    lang: r.lang,
    abortEarly: r.abortEarly,
    abortPipeEarly: r.abortPipeEarly
  }, c = e.kind === "schema", l = (s == null ? void 0 : s.message) ?? e.message ?? /* @__PURE__ */ ja(e.reference, u.lang) ?? (c ? (u.lang, void 0) : null) ?? r.message ?? (u.lang, void 0);
  l && (u.message = typeof l == "function" ? (
    // @ts-expect-error
    l(u)
  ) : l), c && (n.typed = !1), n.issues ? n.issues.push(u) : n.issues = [u];
}
// @__NO_SIDE_EFFECTS__
function K(e) {
  return {
    version: 1,
    vendor: "valibot",
    validate(t) {
      return e["~run"]({ value: t }, /* @__PURE__ */ Kr());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Da(e, t) {
  return Object.hasOwn(e, t) && t !== "__proto__" && t !== "prototype" && t !== "constructor";
}
var Na = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(e) {
    super(e[0].message), this.name = "ValiError", this.issues = e;
  }
};
// @__NO_SIDE_EFFECTS__
function on(e, t, n) {
  return typeof e.default == "function" ? (
    // @ts-expect-error
    e.default(t, n)
  ) : (
    // @ts-expect-error
    e.default
  );
}
// @__NO_SIDE_EFFECTS__
function et(e, t) {
  return !e["~run"]({ value: t }, { abortEarly: !0 }).issues;
}
// @__NO_SIDE_EFFECTS__
function Yr() {
  return {
    kind: "schema",
    type: "any",
    reference: Yr,
    expects: "any",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ K(this);
    },
    "~run"(e) {
      return e.typed = !0, e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function qt(e) {
  return {
    kind: "schema",
    type: "boolean",
    reference: qt,
    expects: "boolean",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ K(this);
    },
    "~run"(t, n) {
      return typeof t.value == "boolean" ? t.typed = !0 : ve(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function an(e) {
  return {
    kind: "schema",
    type: "function",
    reference: an,
    expects: "Function",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ K(this);
    },
    "~run"(t, n) {
      return typeof t.value == "function" ? t.typed = !0 : ve(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function F(e, t) {
  return {
    kind: "schema",
    type: "loose_object",
    reference: F,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ K(this);
    },
    "~run"(n, r) {
      var s;
      const o = n.value;
      if (o && typeof o == "object") {
        n.typed = !0, n.value = {};
        for (const a in this.entries) {
          const i = this.entries[a];
          if (a in o || (i.type === "exact_optional" || i.type === "optional" || i.type === "nullish") && // @ts-expect-error
          i.default !== void 0) {
            const u = a in o ? (
              // @ts-expect-error
              o[a]
            ) : /* @__PURE__ */ on(i), c = i["~run"]({ value: u }, r);
            if (c.issues) {
              const l = {
                type: "object",
                origin: "value",
                input: o,
                key: a,
                value: u
              };
              for (const p of c.issues)
                p.path ? p.path.unshift(l) : p.path = [l], (s = n.issues) == null || s.push(p);
              if (n.issues || (n.issues = c.issues), r.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            c.typed || (n.typed = !1), n.value[a] = c.value;
          } else if (i.type !== "exact_optional" && i.type !== "optional" && i.type !== "nullish" && (ve(this, "key", n, r, {
            input: void 0,
            expected: `"${a}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: o,
                key: a,
                // @ts-expect-error
                value: o[a]
              }
            ]
          }), r.abortEarly))
            break;
        }
        if (!n.issues || !r.abortEarly)
          for (const a in o)
            /* @__PURE__ */ Da(o, a) && !(a in this.entries) && (n.value[a] = o[a]);
      } else
        ve(this, "type", n, r);
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function xe(e, t) {
  return {
    kind: "schema",
    type: "nullish",
    reference: xe,
    expects: `(${e.expects} | null | undefined)`,
    async: !1,
    wrapped: e,
    default: t,
    get "~standard"() {
      return /* @__PURE__ */ K(this);
    },
    "~run"(n, r) {
      return (n.value === null || n.value === void 0) && (this.default !== void 0 && (n.value = /* @__PURE__ */ on(this, n, r)), n.value === null || n.value === void 0) ? (n.typed = !0, n) : this.wrapped["~run"](n, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Dt(e) {
  return {
    kind: "schema",
    type: "number",
    reference: Dt,
    expects: "number",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ K(this);
    },
    "~run"(t, n) {
      return typeof t.value == "number" && !isNaN(t.value) ? t.typed = !0 : ve(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Nt(e, t) {
  return {
    kind: "schema",
    type: "optional",
    reference: Nt,
    expects: `(${e.expects} | undefined)`,
    async: !1,
    wrapped: e,
    default: t,
    get "~standard"() {
      return /* @__PURE__ */ K(this);
    },
    "~run"(n, r) {
      return n.value === void 0 && (this.default !== void 0 && (n.value = /* @__PURE__ */ on(this, n, r)), n.value === void 0) ? (n.typed = !0, n) : this.wrapped["~run"](n, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function re(e) {
  return {
    kind: "schema",
    type: "string",
    reference: re,
    expects: "string",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ K(this);
    },
    "~run"(t, n) {
      return typeof t.value == "string" ? t.typed = !0 : ve(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Zr() {
  return {
    kind: "schema",
    type: "unknown",
    reference: Zr,
    expects: "unknown",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ K(this);
    },
    "~run"(e) {
      return e.typed = !0, e;
    }
  };
}
function Vt(e, t, n) {
  const r = e["~run"]({ value: t }, /* @__PURE__ */ Kr(n));
  if (r.issues)
    throw new Na(r.issues);
  return r.value;
}
// @__NO_SIDE_EFFECTS__
function Xr(...e) {
  return {
    ...e[0],
    pipe: e,
    get "~standard"() {
      return /* @__PURE__ */ K(this);
    },
    "~run"(t, n) {
      for (const r of e)
        if (r.kind !== "metadata") {
          if (t.issues && (r.kind === "schema" || r.kind === "transformation")) {
            t.typed = !1;
            break;
          }
          (!t.issues || !n.abortEarly && !n.abortPipeEarly) && (t = r["~run"](t, n));
        }
      return t;
    }
  };
}
function es(e) {
  return /* @__PURE__ */ et(
    /* @__PURE__ */ F({ TelegramWebviewProxy: /* @__PURE__ */ F({ postEvent: /* @__PURE__ */ an() }) }),
    e
  );
}
function ts() {
  try {
    return window.self !== window.top;
  } catch {
    return !0;
  }
}
var Va = Object.defineProperty, La = (e, t, n) => t in e ? Va(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Lt = (e, t, n) => La(e, typeof t != "symbol" ? t + "" : t, n);
function Ra(e) {
  return (t) => t instanceof e;
}
function ns(e, t) {
  t || (t = []);
  class n extends Error {
    constructor(...s) {
      const o = typeof t == "function" ? t(...s) : typeof t == "string" ? [t] : t || [];
      super(...o), this.name = e;
    }
  }
  return Object.defineProperty(n, "name", { value: e }), [n, Ra(n)];
}
const [Ha, _f] = ns("CancelledError", "Promise was canceled"), [Fa, bf] = ns(
  "TimeoutError",
  (e, t) => [`Timeout reached: ${e}ms`, { cause: t }]
), rs = Symbol("Resolved");
function dr(e) {
  return Array.isArray(e) && e[0] === rs;
}
function Wa(e) {
  return [rs, e];
}
function fr(e, t) {
  return e.reject = t.reject, e.abort = t.abort, e;
}
let un = class Rt extends Promise {
  constructor(t, n) {
    let r, s;
    super((o, a) => {
      let i, u;
      typeof t == "function" ? (i = t, u = n) : u = t;
      const c = [], l = (d) => (...j) => {
        const ee = d(...j);
        return c.forEach(($t) => $t()), ee;
      }, p = new AbortController(), { signal: m } = p;
      s = (d) => {
        !m.aborted && p.abort(d);
      };
      const f = () => m.reason, A = (d) => {
        const j = () => {
          d(f());
        };
        m.addEventListener("abort", j, !0);
        const ee = () => {
          m.removeEventListener("abort", j, !0);
        };
        return c.push(ee), ee;
      }, be = l((d) => {
        o(d), s(Wa(d));
      });
      r = l((d) => {
        a(d), s(d);
      }), u || (u = {});
      const { abortSignal: M, rejectOnAbort: ne = !0 } = u;
      if (M)
        if (M.aborted) {
          const { reason: d } = M;
          if (ne)
            return r(d);
          s(d);
        } else {
          const d = () => {
            s(M.reason);
          };
          M.addEventListener("abort", d), c.push(() => {
            M.removeEventListener("abort", d);
          });
        }
      ne && A(a);
      const { timeout: E } = u;
      if (E) {
        const d = setTimeout(() => {
          s(new Fa(E));
        }, E);
        c.push(() => {
          clearTimeout(d);
        });
      }
      const $ = () => m.aborted, I = () => dr(f()), V = () => {
        const d = f();
        return dr(d) ? d[1] : void 0;
      };
      try {
        const d = i && i(be, r, {
          abortReason: f,
          abortSignal: m,
          isAborted: $,
          isResolved: I,
          onAborted: A,
          onResolved: (j) => A(() => {
            I() && j(V());
          }),
          resolved: V,
          throwIfAborted() {
            if ($())
              throw f();
          }
        });
        d instanceof Promise && d.catch(r);
      } catch (d) {
        r(d);
      }
    }), Lt(this, "abort"), Lt(this, "reject"), this.abort = s, this.reject = r;
  }
  /**
   * Creates a new AbortablePromise instance using an executor, resolving the promise when a result
   * was returned.
   * @param fn - function returning promise result.
   * @param options - additional options.
   */
  static fn(t, n) {
    return new Rt(async (r, s, o) => {
      try {
        r(await t(o));
      } catch (a) {
        s(a);
      }
    }, n);
  }
  static resolve(t) {
    return this.fn(() => t);
  }
  /**
   * @see Promise.reject
   */
  static reject(t) {
    return new Rt((n, r) => {
      r(t);
    });
  }
  /**
   * Aborts the promise with the cancel error.
   */
  cancel() {
    this.abort(new Ha());
  }
  /**
   * @see Promise.catch
   */
  catch(t) {
    return this.then(void 0, t);
  }
  /**
   * @see Promise.finally
   */
  finally(t) {
    return fr(super.finally(t), this);
  }
  /**
   * @see Promise.then
   */
  then(t, n) {
    return fr(super.then(t, n), this);
  }
};
function mr(e, t) {
  return e.resolve = t.resolve, e;
}
let yf = class Ht extends un {
  constructor(t, n) {
    let r, s;
    typeof t == "function" ? (r = t, s = n) : s = t;
    let o;
    super((a, i, u) => {
      o = a, r && r(a, i, u);
    }, s), Lt(this, "resolve"), this.resolve = o;
  }
  /**
   * Creates a new ManualPromise instance using an executor, resolving the promise when a result
   * was returned.
   * @param fn - function returning promise result.
   * @param options - additional options.
   */
  static fn(t, n) {
    return new Ht((r, s, o) => {
      try {
        Promise.resolve(t(o)).then(r, s);
      } catch (a) {
        s(a);
      }
    }, n);
  }
  static resolve(t) {
    return this.fn(() => t);
  }
  /**
   * @see Promise.reject
   */
  static reject(t) {
    return new Ht((n, r) => {
      r(t);
    });
  }
  /**
   * @see Promise.catch
   */
  catch(t) {
    return this.then(void 0, t);
  }
  /**
   * @see Promise.finally
   */
  finally(t) {
    return mr(super.finally(t), this);
  }
  /**
   * @see Promise.then
   */
  then(t, n) {
    return mr(super.then(t, n), this);
  }
};
function Ua(e) {
  return e.replace(/_[a-z]/g, (t) => t[1].toUpperCase());
}
function za(e) {
  return Object.entries(e).reduce((t, [n, r]) => (t[Ua(n)] = r, t), {});
}
function Ft(e) {
  const t = za(e);
  for (const n in t) {
    const r = t[n];
    r && typeof r == "object" && !(r instanceof Date) && (t[n] = Array.isArray(r) ? r.map(Ft) : Ft(r));
  }
  return t;
}
function ss(e) {
  return `tapps/${e}`;
}
function os(e, t) {
  sessionStorage.setItem(ss(e), JSON.stringify(t));
}
function Ga(e) {
  const t = sessionStorage.getItem(ss(e));
  try {
    return t ? JSON.parse(t) : void 0;
  } catch {
  }
}
function Qa(...e) {
  const t = e.flat(1);
  return [
    t.push.bind(t),
    () => {
      t.forEach((n) => {
        n();
      });
    }
  ];
}
// @__NO_SIDE_EFFECTS__
function Ja(e, t) {
  t || (t = {});
  const {
    textColor: n,
    bgColor: r,
    shouldLog: s
  } = t, o = s === void 0 ? !0 : s, a = typeof o == "boolean" ? () => o : o;
  function i(u, c, ...l) {
    if (c || a()) {
      const p = "font-weight:bold;padding:0 5px;border-radius:5px";
      console[u](
        `%c${Intl.DateTimeFormat("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          fractionalSecondDigits: 3,
          timeZone: "UTC"
        }).format(/* @__PURE__ */ new Date())}%c / %c${e}`,
        `${p};background-color: lightblue;color:black`,
        "",
        `${p};${n ? `color:${n};` : ""}${r ? `background-color:${r}` : ""}`,
        ...l
      );
    }
  }
  return [i.bind(void 0, "log"), i.bind(void 0, "error")];
}
// @__NO_SIDE_EFFECTS__
function as(e) {
  return {
    lang: (e == null ? void 0 : e.lang) ?? void 0,
    message: e == null ? void 0 : e.message,
    abortEarly: (e == null ? void 0 : e.abortEarly) ?? void 0,
    abortPipeEarly: (e == null ? void 0 : e.abortPipeEarly) ?? void 0
  };
}
// @__NO_SIDE_EFFECTS__
function Ka(e, t) {
  var n;
  return (n = void 0) == null ? void 0 : n.get(t);
}
// @__NO_SIDE_EFFECTS__
function Ya(e) {
  var t, n;
  const r = typeof e;
  return r === "string" ? `"${e}"` : r === "number" || r === "bigint" || r === "boolean" ? `${e}` : r === "object" || r === "function" ? (e && ((n = (t = Object.getPrototypeOf(e)) == null ? void 0 : t.constructor) == null ? void 0 : n.name)) ?? "null" : r;
}
function q(e, t, n, r, s) {
  const o = s && "input" in s ? s.input : n.value, a = (s == null ? void 0 : s.expected) ?? e.expects ?? null, i = (s == null ? void 0 : s.received) ?? /* @__PURE__ */ Ya(o), u = {
    kind: e.kind,
    type: e.type,
    input: o,
    expected: a,
    received: i,
    message: `Invalid ${t}: ${a ? `Expected ${a} but r` : "R"}eceived ${i}`,
    requirement: e.requirement,
    path: s == null ? void 0 : s.path,
    issues: s == null ? void 0 : s.issues,
    lang: r.lang,
    abortEarly: r.abortEarly,
    abortPipeEarly: r.abortPipeEarly
  }, c = e.kind === "schema", l = (s == null ? void 0 : s.message) ?? e.message ?? /* @__PURE__ */ Ka(e.reference, u.lang) ?? (c ? (u.lang, void 0) : null) ?? r.message ?? (u.lang, void 0);
  l && (u.message = typeof l == "function" ? (
    // @ts-expect-error
    l(u)
  ) : l), c && (n.typed = !1), n.issues ? n.issues.push(u) : n.issues = [u];
}
// @__NO_SIDE_EFFECTS__
function R(e) {
  return {
    version: 1,
    vendor: "valibot",
    validate(t) {
      return e["~run"]({ value: t }, /* @__PURE__ */ as());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function is(e, t) {
  return Object.hasOwn(e, t) && t !== "__proto__" && t !== "prototype" && t !== "constructor";
}
// @__NO_SIDE_EFFECTS__
function Za(e, t) {
  const n = [...new Set(e)];
  return n.length > 1 ? `(${n.join(` ${t} `)})` : n[0] ?? "never";
}
var Xa = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(e) {
    super(e[0].message), this.name = "ValiError", this.issues = e;
  }
};
// @__NO_SIDE_EFFECTS__
function us(e, t) {
  return {
    kind: "validation",
    type: "check",
    reference: us,
    async: !1,
    expects: null,
    requirement: e,
    message: t,
    "~run"(n, r) {
      return n.typed && !this.requirement(n.value) && q(this, "input", n, r), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function cs(e) {
  return {
    kind: "validation",
    type: "integer",
    reference: cs,
    async: !1,
    expects: null,
    requirement: Number.isInteger,
    message: e,
    "~run"(t, n) {
      return t.typed && !this.requirement(t.value) && q(this, "integer", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function oe(e) {
  return {
    kind: "transformation",
    type: "transform",
    reference: oe,
    async: !1,
    operation: e,
    "~run"(t) {
      return t.value = this.operation(t.value), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ls(e, t, n) {
  return typeof e.default == "function" ? (
    // @ts-expect-error
    e.default(t, n)
  ) : (
    // @ts-expect-error
    e.default
  );
}
// @__NO_SIDE_EFFECTS__
function ei(e, t) {
  return !e["~run"]({ value: t }, { abortEarly: !0 }).issues;
}
// @__NO_SIDE_EFFECTS__
function Te(e) {
  return {
    kind: "schema",
    type: "boolean",
    reference: Te,
    expects: "boolean",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ R(this);
    },
    "~run"(t, n) {
      return typeof t.value == "boolean" ? t.typed = !0 : q(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ps(e) {
  return {
    kind: "schema",
    type: "date",
    reference: ps,
    expects: "Date",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ R(this);
    },
    "~run"(t, n) {
      return t.value instanceof Date ? isNaN(t.value) ? q(this, "type", t, n, {
        received: '"Invalid Date"'
      }) : t.typed = !0 : q(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ds(e, t) {
  return {
    kind: "schema",
    type: "instance",
    reference: ds,
    expects: e.name,
    async: !1,
    class: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ R(this);
    },
    "~run"(n, r) {
      return n.value instanceof this.class ? n.typed = !0 : q(this, "type", n, r), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function cn(e) {
  return {
    kind: "schema",
    type: "lazy",
    reference: cn,
    expects: "unknown",
    async: !1,
    getter: e,
    get "~standard"() {
      return /* @__PURE__ */ R(this);
    },
    "~run"(t, n) {
      return this.getter(t.value)["~run"](t, n);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function $e(e, t) {
  return {
    kind: "schema",
    type: "loose_object",
    reference: $e,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ R(this);
    },
    "~run"(n, r) {
      var s;
      const o = n.value;
      if (o && typeof o == "object") {
        n.typed = !0, n.value = {};
        for (const a in this.entries) {
          const i = this.entries[a];
          if (a in o || (i.type === "exact_optional" || i.type === "optional" || i.type === "nullish") && // @ts-expect-error
          i.default !== void 0) {
            const u = a in o ? (
              // @ts-expect-error
              o[a]
            ) : /* @__PURE__ */ ls(i), c = i["~run"]({ value: u }, r);
            if (c.issues) {
              const l = {
                type: "object",
                origin: "value",
                input: o,
                key: a,
                value: u
              };
              for (const p of c.issues)
                p.path ? p.path.unshift(l) : p.path = [l], (s = n.issues) == null || s.push(p);
              if (n.issues || (n.issues = c.issues), r.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            c.typed || (n.typed = !1), n.value[a] = c.value;
          } else if (i.type !== "exact_optional" && i.type !== "optional" && i.type !== "nullish" && (q(this, "key", n, r, {
            input: void 0,
            expected: `"${a}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: o,
                key: a,
                // @ts-expect-error
                value: o[a]
              }
            ]
          }), r.abortEarly))
            break;
        }
        if (!n.issues || !r.abortEarly)
          for (const a in o)
            /* @__PURE__ */ is(o, a) && !(a in this.entries) && (n.value[a] = o[a]);
      } else
        q(this, "type", n, r);
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function tt(e) {
  return {
    kind: "schema",
    type: "number",
    reference: tt,
    expects: "number",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ R(this);
    },
    "~run"(t, n) {
      return typeof t.value == "number" && !isNaN(t.value) ? t.typed = !0 : q(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function v(e, t) {
  return {
    kind: "schema",
    type: "optional",
    reference: v,
    expects: `(${e.expects} | undefined)`,
    async: !1,
    wrapped: e,
    default: t,
    get "~standard"() {
      return /* @__PURE__ */ R(this);
    },
    "~run"(n, r) {
      return n.value === void 0 && (this.default !== void 0 && (n.value = /* @__PURE__ */ ls(this, n, r)), n.value === void 0) ? (n.typed = !0, n) : this.wrapped["~run"](n, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function fs(e, t, n) {
  return {
    kind: "schema",
    type: "record",
    reference: fs,
    expects: "Object",
    async: !1,
    key: e,
    value: t,
    message: n,
    get "~standard"() {
      return /* @__PURE__ */ R(this);
    },
    "~run"(r, s) {
      var o, a;
      const i = r.value;
      if (i && typeof i == "object") {
        r.typed = !0, r.value = {};
        for (const u in i)
          if (/* @__PURE__ */ is(i, u)) {
            const c = i[u], l = this.key["~run"]({ value: u }, s);
            if (l.issues) {
              const m = {
                type: "object",
                origin: "key",
                input: i,
                key: u,
                value: c
              };
              for (const f of l.issues)
                f.path = [m], (o = r.issues) == null || o.push(f);
              if (r.issues || (r.issues = l.issues), s.abortEarly) {
                r.typed = !1;
                break;
              }
            }
            const p = this.value["~run"](
              { value: c },
              s
            );
            if (p.issues) {
              const m = {
                type: "object",
                origin: "value",
                input: i,
                key: u,
                value: c
              };
              for (const f of p.issues)
                f.path ? f.path.unshift(m) : f.path = [m], (a = r.issues) == null || a.push(f);
              if (r.issues || (r.issues = p.issues), s.abortEarly) {
                r.typed = !1;
                break;
              }
            }
            (!l.typed || !p.typed) && (r.typed = !1), l.typed && (r.value[l.value] = p.value);
          }
      } else
        q(this, "type", r, s);
      return r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function y(e) {
  return {
    kind: "schema",
    type: "string",
    reference: y,
    expects: "string",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ R(this);
    },
    "~run"(t, n) {
      return typeof t.value == "string" ? t.typed = !0 : q(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function hr(e) {
  let t;
  if (e)
    for (const n of e)
      t ? t.push(...n.issues) : t = n.issues;
  return t;
}
// @__NO_SIDE_EFFECTS__
function ln(e, t) {
  return {
    kind: "schema",
    type: "union",
    reference: ln,
    expects: /* @__PURE__ */ Za(
      e.map((n) => n.expects),
      "|"
    ),
    async: !1,
    options: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ R(this);
    },
    "~run"(n, r) {
      let s, o, a;
      for (const i of this.options) {
        const u = i["~run"]({ value: n.value }, r);
        if (u.typed)
          if (u.issues)
            o ? o.push(u) : o = [u];
          else {
            s = u;
            break;
          }
        else
          a ? a.push(u) : a = [u];
      }
      if (s)
        return s;
      if (o) {
        if (o.length === 1)
          return o[0];
        q(this, "type", n, r, {
          issues: /* @__PURE__ */ hr(o)
        }), n.typed = !0;
      } else {
        if ((a == null ? void 0 : a.length) === 1)
          return a[0];
        q(this, "type", n, r, {
          issues: /* @__PURE__ */ hr(a)
        });
      }
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ms() {
  return {
    kind: "schema",
    type: "unknown",
    reference: ms,
    expects: "unknown",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ R(this);
    },
    "~run"(e) {
      return e.typed = !0, e;
    }
  };
}
function hs(e, t, n) {
  const r = e["~run"]({ value: t }, /* @__PURE__ */ as(n));
  if (r.issues)
    throw new Xa(r.issues);
  return r.value;
}
// @__NO_SIDE_EFFECTS__
function ae(...e) {
  return {
    ...e[0],
    pipe: e,
    get "~standard"() {
      return /* @__PURE__ */ R(this);
    },
    "~run"(t, n) {
      for (const r of e)
        if (r.kind !== "metadata") {
          if (t.issues && (r.kind === "schema" || r.kind === "transformation")) {
            t.typed = !1;
            break;
          }
          (!t.issues || !n.abortEarly && !n.abortPipeEarly) && (t = r["~run"](t, n));
        }
      return t;
    }
  };
}
function ti(e) {
  return e.replace(/_[a-z]/g, (t) => t[1].toUpperCase());
}
function ni(e) {
  return Object.entries(e).reduce((t, [n, r]) => (t[ti(n)] = r, t), {});
}
function Wt(e) {
  const t = ni(e);
  for (const n in t) {
    const r = t[n];
    r && typeof r == "object" && !(r instanceof Date) && (t[n] = Array.isArray(r) ? r.map(Wt) : Wt(r));
  }
  return t;
}
function pn(e) {
  return /* @__PURE__ */ oe((t) => e ? Wt(t) : t);
}
function _s(e) {
  return (t) => /* @__PURE__ */ ae(
    e,
    pn(t)
  );
}
function ri(e) {
  return (t, n) => hs(
    /* @__PURE__ */ ae(e, pn(n)),
    t
  );
}
function dn() {
  return /* @__PURE__ */ oe(JSON.parse);
}
function fn(e) {
  const t = _s(e);
  return (n) => /* @__PURE__ */ ae(
    /* @__PURE__ */ y(),
    dn(),
    t(n)
  );
}
function si(e) {
  return /* @__PURE__ */ oe((t) => {
    const n = {};
    return new URLSearchParams(t).forEach((r, s) => {
      const o = n[s];
      Array.isArray(o) ? o.push(r) : o === void 0 ? n[s] = r : n[s] = [o, r];
    }), hs(e, n);
  });
}
function bs(e) {
  return (t) => /* @__PURE__ */ ae(
    /* @__PURE__ */ ln([/* @__PURE__ */ y(), /* @__PURE__ */ ds(URLSearchParams)]),
    si(e),
    pn(t)
  );
}
const _r = /* @__PURE__ */ v(/* @__PURE__ */ cn(() => ci())), oi = /* @__PURE__ */ $e({
  id: /* @__PURE__ */ tt(),
  photo_url: /* @__PURE__ */ v(/* @__PURE__ */ y()),
  type: /* @__PURE__ */ y(),
  title: /* @__PURE__ */ y(),
  username: /* @__PURE__ */ v(/* @__PURE__ */ y())
}), ai = /* @__PURE__ */ $e({
  added_to_attachment_menu: /* @__PURE__ */ v(/* @__PURE__ */ Te()),
  allows_write_to_pm: /* @__PURE__ */ v(/* @__PURE__ */ Te()),
  first_name: /* @__PURE__ */ y(),
  id: /* @__PURE__ */ tt(),
  is_bot: /* @__PURE__ */ v(/* @__PURE__ */ Te()),
  is_premium: /* @__PURE__ */ v(/* @__PURE__ */ Te()),
  last_name: /* @__PURE__ */ v(/* @__PURE__ */ y()),
  language_code: /* @__PURE__ */ v(/* @__PURE__ */ y()),
  photo_url: /* @__PURE__ */ v(/* @__PURE__ */ y()),
  username: /* @__PURE__ */ v(/* @__PURE__ */ y())
}), ii = /* @__PURE__ */ $e({
  auth_date: /* @__PURE__ */ ae(
    /* @__PURE__ */ y(),
    /* @__PURE__ */ oe((e) => new Date(Number(e) * 1e3)),
    /* @__PURE__ */ ps()
  ),
  can_send_after: /* @__PURE__ */ v(/* @__PURE__ */ ae(/* @__PURE__ */ y(), /* @__PURE__ */ oe(Number), /* @__PURE__ */ cs())),
  chat: /* @__PURE__ */ v(/* @__PURE__ */ cn(() => ui())),
  chat_type: /* @__PURE__ */ v(/* @__PURE__ */ y()),
  chat_instance: /* @__PURE__ */ v(/* @__PURE__ */ y()),
  hash: /* @__PURE__ */ y(),
  query_id: /* @__PURE__ */ v(/* @__PURE__ */ y()),
  receiver: _r,
  start_param: /* @__PURE__ */ v(/* @__PURE__ */ y()),
  signature: /* @__PURE__ */ y(),
  user: _r
}), ui = fn(oi), ci = fn(ai), li = bs(ii);
function pi(e) {
  return /^#[\da-f]{6}$/i.test(e);
}
const ys = _s(
  /* @__PURE__ */ fs(
    /* @__PURE__ */ y(),
    /* @__PURE__ */ ae(
      /* @__PURE__ */ ln([/* @__PURE__ */ y(), /* @__PURE__ */ tt()]),
      /* @__PURE__ */ oe((e) => typeof e == "number" ? `#${(e & 16777215).toString(16).padStart(6, "0")}` : e),
      /* @__PURE__ */ us(pi)
    )
  )
), St = /* @__PURE__ */ v(
  /* @__PURE__ */ ae(/* @__PURE__ */ y(), /* @__PURE__ */ oe((e) => e === "1"))
), br = fn(ys()), di = /* @__PURE__ */ $e({
  tgWebAppBotInline: St,
  tgWebAppData: /* @__PURE__ */ v(li()),
  tgWebAppDefaultColors: /* @__PURE__ */ v(br()),
  tgWebAppFullscreen: St,
  tgWebAppPlatform: /* @__PURE__ */ y(),
  tgWebAppShowSettings: St,
  tgWebAppStartParam: /* @__PURE__ */ v(/* @__PURE__ */ y()),
  tgWebAppThemeParams: br(),
  tgWebAppVersion: /* @__PURE__ */ y()
}), gs = bs(di), fi = ri(gs()), vs = /* @__PURE__ */ $e({
  eventType: /* @__PURE__ */ y(),
  eventData: /* @__PURE__ */ v(/* @__PURE__ */ ms())
});
function ws(e, t) {
  return t || (t = (n, r) => JSON.stringify(r)), new URLSearchParams(
    Object.entries(e).reduce((n, [r, s]) => (Array.isArray(s) ? n.push(...s.map((o) => [r, String(o)])) : s != null && n.push([
      r,
      s instanceof Date ? (s.getTime() / 1e3 | 0).toString() : typeof s == "string" || typeof s == "number" ? String(s) : typeof s == "boolean" ? s ? "1" : "0" : t(r, s)
    ]), n), [])
  ).toString();
}
function mi(e) {
  return ws(e);
}
function hi(e) {
  return ws(e, (t, n) => t === "tgWebAppData" ? mi(n) : JSON.stringify(n));
}
function Es(e) {
  try {
    return /* @__PURE__ */ ei(gs(), e);
  } catch {
    return !1;
  }
}
function _i(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, n) {
    var r = e.get(t);
    r ? r.push(n) : e.set(t, [n]);
  }, off: function(t, n) {
    var r = e.get(t);
    r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, n) {
    var r = e.get(t);
    r && r.slice().map(function(s) {
      s(n);
    }), (r = e.get("*")) && r.slice().map(function(s) {
      s(t, n);
    });
  } };
}
function bi(e, t) {
  const n = _i(), r = /* @__PURE__ */ new Map(), s = (o, a, i) => {
    i || (i = !1);
    const u = r.get(o) || /* @__PURE__ */ new Map();
    r.set(o, u);
    const c = u.get(a) || [];
    u.set(a, c);
    const l = c.findIndex((p) => p[1] === i);
    l >= 0 && (n.off(o, c[l][0]), c.splice(l, 1), !c.length && u.delete(a), u.size || (r.delete(o), !r.size && t()));
  };
  return [
    function(o, a, i) {
      !r.size && e();
      function u() {
        s(o, a, i);
      }
      function c(...m) {
        i && u(), o === "*" ? a(m) : a(...m);
      }
      n.on(o, c);
      const l = r.get(o) || /* @__PURE__ */ new Map();
      r.set(o, l);
      const p = l.get(a) || [];
      return l.set(a, p), p.push([c, i || !1]), u;
    },
    s,
    // eslint-disable-next-line @typescript-eslint/unbound-method
    n.emit,
    function() {
      const o = n.all.size;
      n.all.clear(), r.clear(), o && t();
    }
  ];
}
function yr(e, t) {
  window.dispatchEvent(new MessageEvent("message", {
    data: JSON.stringify({ eventType: e, eventData: t }),
    // We specify window.parent to imitate the case, the parent iframe sent us this event.
    source: window.parent
  }));
}
let We = !1;
const [mn, yi] = /* @__PURE__ */ Ja("Bridge", {
  bgColor: "#9147ff",
  textColor: "white",
  shouldLog() {
    return We;
  }
}), gr = (e) => {
  mn(!1, "Event received:", e);
};
function gi(e) {
  e !== We && (We = e, We ? k("*", gr) : B("*", gr));
}
const vi = {
  clipboard_text_received: /* @__PURE__ */ F({
    req_id: /* @__PURE__ */ re(),
    data: /* @__PURE__ */ xe(/* @__PURE__ */ re())
  }),
  custom_method_invoked: /* @__PURE__ */ F({
    req_id: /* @__PURE__ */ re(),
    result: /* @__PURE__ */ Nt(/* @__PURE__ */ Zr()),
    error: /* @__PURE__ */ Nt(/* @__PURE__ */ re())
  }),
  popup_closed: /* @__PURE__ */ xe(
    /* @__PURE__ */ F({ button_id: /* @__PURE__ */ xe(/* @__PURE__ */ re(), () => {
    }) }),
    {}
  ),
  viewport_changed: /* @__PURE__ */ F({
    height: /* @__PURE__ */ Dt(),
    width: /* @__PURE__ */ xe(/* @__PURE__ */ Dt(), () => window.innerWidth),
    is_state_stable: /* @__PURE__ */ qt(),
    is_expanded: /* @__PURE__ */ qt()
  }),
  theme_changed: /* @__PURE__ */ F({
    theme_params: ys()
  })
};
function vr(e) {
  if (e.source !== window.parent)
    return;
  let t;
  try {
    t = Vt(/* @__PURE__ */ Xr(/* @__PURE__ */ re(), dn(), vs), e.data);
  } catch {
    return;
  }
  const { eventType: n, eventData: r } = t, s = vi[n];
  try {
    const o = s ? Vt(s, r) : r;
    wi(n, o);
  } catch (o) {
    yi(
      !0,
      [
        `An error occurred processing the "${n}" event from the Telegram application.`,
        "Please, file an issue here:",
        "https://github.com/Telegram-Mini-Apps/telegram-apps/issues/new/choose"
      ].join(`
`),
      t,
      o
    );
  }
}
const [
  k,
  B,
  wi,
  gf
] = bi(
  () => {
    const e = window, t = { receiveEvent: yr };
    e.TelegramGameProxy_receiveEvent = yr, e.TelegramGameProxy = t, e.Telegram = { WebView: t }, window.addEventListener("message", vr);
  },
  () => {
    ["TelegramGameProxy_receiveEvent", "TelegramGameProxy", "Telegram"].forEach((e) => {
      delete window[e];
    }), window.removeEventListener("message", vr);
  }
);
function Ei(e) {
  return (t) => t instanceof e;
}
function Se(e, t) {
  t || (t = []);
  class n extends Error {
    constructor(...s) {
      const o = typeof t == "function" ? t(...s) : typeof t == "string" ? [t] : t || [];
      super(...o), this.name = e;
    }
  }
  return Object.defineProperty(n, "name", { value: e }), [n, Ei(n)];
}
const [
  $i,
  vf
] = Se(
  "MethodUnsupportedError",
  (e, t) => [
    `Method "${e}" is unsupported in Mini Apps version ${t}`
  ]
), [
  Si,
  wf
] = Se(
  "MethodParameterUnsupportedError",
  (e, t, n) => [
    `Parameter "${t}" of "${e}" method is unsupported in Mini Apps version ${n}`
  ]
), Ci = [
  "Unable to retrieve launch parameters from any known source. Perhaps, you have opened your app outside Telegram?",
  "📖 Refer to docs for more information:",
  "https://docs.telegram-mini-apps.com/packages/telegram-apps-bridge/environment"
].join(`
`), [
  ki,
  Ef
] = Se("LaunchParamsRetrieveError", Ci), [
  Ai,
  $f
] = Se("InvalidLaunchParamsError", (e) => [
  `Invalid value for launch params: ${e}`
]), [Mi, Sf] = Se("UnknownEnvError"), [
  Pi,
  Cf
] = Se(
  "InvokeCustomMethodError",
  (e) => [`Server returned error: ${e}`]
);
function xi(e, t) {
  t();
}
// @__NO_SIDE_EFFECTS__
function Ti(e, t) {
  t || (t = {});
  const n = t.equals || Object.is;
  let r = [], s = e;
  const o = (c) => {
    if (!n(s, c)) {
      const l = s;
      s = c, xi(u, () => {
        [...r].forEach(([p, m]) => {
          p(c, l), m && i(p, !0);
        });
      });
    }
  };
  function a(c) {
    const l = typeof c != "object" ? { once: c } : c;
    return {
      once: l.once || !1,
      signal: l.signal || !1
    };
  }
  const i = (c, l) => {
    const p = a(l), m = r.findIndex(([f, A]) => f === c && A.once === p.once && A.signal === p.signal);
    m >= 0 && r.splice(m, 1);
  }, u = Object.assign(
    function() {
      return Bi(u), s;
    },
    {
      destroy() {
        r = [];
      },
      set: o,
      reset() {
        o(e);
      },
      sub(c, l) {
        return r.push([c, a(l)]), () => i(c, l);
      },
      unsub: i,
      unsubAll() {
        r = r.filter((c) => c[1].signal);
      }
    }
  );
  return u;
}
const Ct = [];
function Bi(e) {
  Ct.length && Ct[Ct.length - 1].add(e);
}
const Oi = /* @__PURE__ */ Ti("https://web.telegram.org");
function hn(e, t) {
  mn(!1, "Posting event:", t ? { eventType: e, eventData: t } : { eventType: e });
  const n = window, r = JSON.stringify({ eventType: e, eventData: t });
  if (ts())
    return n.parent.postMessage(r, Oi());
  if (es(n)) {
    n.TelegramWebviewProxy.postEvent(e, JSON.stringify(t));
    return;
  }
  if (/* @__PURE__ */ et(/* @__PURE__ */ F({ external: /* @__PURE__ */ F({ notify: /* @__PURE__ */ an() }) }), n)) {
    n.external.notify(r);
    return;
  }
  throw new Mi();
}
function _n(e, t, n) {
  n || (n = {});
  const { capture: r } = n, [s, o] = Qa();
  return new un((a) => {
    (Array.isArray(t) ? t : [t]).forEach((i) => {
      s(
        k(i, (u) => {
          (!r || (Array.isArray(t) ? r({
            event: i,
            payload: u
          }) : r(u))) && a(u);
        })
      );
    }), (n.postEvent || hn)(e, n.params);
  }, n).finally(o);
}
const wr = "launchParams";
function Er(e) {
  return e.replace(/^[^?#]*[?#]/, "").replace(/[?#]/g, "&");
}
function $s() {
  for (const e of [
    // Try to retrieve launch parameters from the current location. This method can return
    // nothing in case, location was changed, and then the page was reloaded.
    () => Er(window.location.href),
    // Then, try using the lower level API - window.performance.
    () => {
      const t = performance.getEntriesByType("navigation")[0];
      return t && Er(t.name);
    },
    () => Ga(wr)
  ]) {
    const t = e();
    if (t && Es(t))
      return os(wr, t), t;
  }
  throw new ki();
}
function bn(e) {
  const t = fi($s());
  return e ? Ft(t) : t;
}
function $r(e, t) {
  if (!e)
    try {
      return bn(), !0;
    } catch {
      return !1;
    }
  return un.fn(async (n) => {
    if (es(window))
      return !0;
    try {
      return await _n("web_app_request_theme", "theme_changed", n), !0;
    } catch {
      return !1;
    }
  }, t || { timeout: 100 });
}
function kf({ launchParams: e, onEvent: t } = {}) {
  if (e) {
    const s = typeof e == "string" || e instanceof URLSearchParams ? e.toString() : (
      // Here we have to trick serializeLaunchParamsQuery into thinking, it serializes a valid
      // value. We are doing it because we are working with tgWebAppData presented as a
      // string, not an object as serializeLaunchParamsQuery requires.
      hi({ ...e, tgWebAppData: void 0 }) + (e.tgWebAppData ? `&tgWebAppData=${encodeURIComponent(e.tgWebAppData.toString())}` : "")
    );
    if (!Es(s))
      throw new Ai(s);
    os("launchParams", s);
  }
  if (ts()) {
    const s = /* @__PURE__ */ Xr(
      /* @__PURE__ */ re(),
      dn(),
      vs
    ), o = window.parent.postMessage.bind(window.parent);
    window.parent.postMessage = (...a) => {
      const [i] = a, u = () => {
        o(...a);
      };
      if (/* @__PURE__ */ et(s, i) && t) {
        const c = Vt(s, i);
        t([c.eventType, c.eventData], u);
      } else
        u();
    };
    return;
  }
  const n = window.TelegramWebviewProxy || {}, { postEvent: r } = n;
  window.TelegramWebviewProxy = {
    ...n,
    postEvent(s, o) {
      const a = () => {
        r && r(s, o);
      };
      t ? t([s, o ? JSON.parse(o) : void 0], a) : a();
    }
  }, mn(!1, "Environment was mocked by the mockTelegramEnv function");
}
function Ii() {
  return new URLSearchParams($s()).get("tgWebAppData") || void 0;
}
function Ss(e) {
  return ({ req_id: t }) => t === e;
}
function Sr(e) {
  return e.split(".").map(Number);
}
function ji(e, t) {
  const n = Sr(e), r = Sr(t), s = Math.max(n.length, r.length);
  for (let o = 0; o < s; o += 1) {
    const a = n[o] || 0, i = r[o] || 0;
    if (a !== i)
      return a > i ? 1 : -1;
  }
  return 0;
}
function P(e, t) {
  return ji(e, t) <= 0;
}
function de(e, t, n) {
  if (typeof n == "string") {
    if (e === "web_app_open_link") {
      if (t === "try_instant_view")
        return P("6.4", n);
      if (t === "try_browser")
        return P("7.6", n);
    }
    if (e === "web_app_set_header_color" && t === "color")
      return P("6.9", n);
    if (e === "web_app_close" && t === "return_back")
      return P("7.6", n);
    if (e === "web_app_setup_main_button" && t === "has_shine_effect")
      return P("7.10", n);
  }
  switch (e) {
    case "web_app_open_tg_link":
    case "web_app_open_invoice":
    case "web_app_setup_back_button":
    case "web_app_set_background_color":
    case "web_app_set_header_color":
    case "web_app_trigger_haptic_feedback":
      return P("6.1", t);
    case "web_app_open_popup":
      return P("6.2", t);
    case "web_app_close_scan_qr_popup":
    case "web_app_open_scan_qr_popup":
    case "web_app_read_text_from_clipboard":
      return P("6.4", t);
    case "web_app_switch_inline_query":
      return P("6.7", t);
    case "web_app_invoke_custom_method":
    case "web_app_request_write_access":
    case "web_app_request_phone":
      return P("6.9", t);
    case "web_app_setup_settings_button":
      return P("6.10", t);
    case "web_app_biometry_get_info":
    case "web_app_biometry_open_settings":
    case "web_app_biometry_request_access":
    case "web_app_biometry_request_auth":
    case "web_app_biometry_update_token":
      return P("7.2", t);
    case "web_app_setup_swipe_behavior":
      return P("7.7", t);
    case "web_app_share_to_story":
      return P("7.8", t);
    case "web_app_setup_secondary_button":
    case "web_app_set_bottom_bar_color":
      return P("7.10", t);
    case "web_app_request_safe_area":
    case "web_app_request_content_safe_area":
    case "web_app_request_fullscreen":
    case "web_app_exit_fullscreen":
    case "web_app_set_emoji_status":
    case "web_app_add_to_home_screen":
    case "web_app_check_home_screen":
    case "web_app_request_emoji_status_access":
    case "web_app_check_location":
    case "web_app_open_location_settings":
    case "web_app_request_file_download":
    case "web_app_request_location":
    case "web_app_send_prepared_message":
    case "web_app_start_accelerometer":
    case "web_app_start_device_orientation":
    case "web_app_start_gyroscope":
    case "web_app_stop_accelerometer":
    case "web_app_stop_device_orientation":
    case "web_app_stop_gyroscope":
    case "web_app_toggle_orientation_lock":
      return P("8.0", t);
    default:
      return [
        "iframe_ready",
        "iframe_will_reload",
        "web_app_close",
        "web_app_data_send",
        "web_app_expand",
        "web_app_open_link",
        "web_app_ready",
        "web_app_request_theme",
        "web_app_request_viewport",
        "web_app_setup_main_button",
        "web_app_setup_closing_behavior"
      ].includes(e);
  }
}
function qi(e, t) {
  t || (t = "strict");
  const n = typeof t == "function" ? t : (r) => {
    const { method: s, version: o } = r, a = "param" in r ? new Si(s, r.param, o) : new $i(s, o);
    if (t === "strict")
      throw a;
    return console.warn(a.message);
  };
  return (r, s) => de(r, e) ? r === "web_app_set_header_color" && /* @__PURE__ */ et(/* @__PURE__ */ F({ color: /* @__PURE__ */ Yr() }), s) && !de(r, "color", e) ? n({ version: e, method: r, param: "color" }) : hn(r, s) : n({ version: e, method: r });
}
function Di(e, t, n, r) {
  return _n("web_app_invoke_custom_method", "custom_method_invoked", {
    ...r || {},
    params: { method: e, params: t, req_id: n },
    capture: Ss(n)
  }).then(({ result: s, error: o }) => {
    if (o)
      throw new Pi(o);
    return s;
  });
}
function Cs(e) {
  return e.replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`);
}
function Ni(e) {
  return e.replace(/_([a-z])/g, (t, n) => `-${n.toLowerCase()}`);
}
function ks(e) {
  return `tapps/${e}`;
}
function W(e, t) {
  sessionStorage.setItem(ks(e), JSON.stringify(t));
}
function U(e) {
  const t = sessionStorage.getItem(ks(e));
  try {
    return t ? JSON.parse(t) : void 0;
  } catch {
  }
}
function yn(...e) {
  const t = e.flat(1);
  return [
    t.push.bind(t),
    () => {
      t.forEach((n) => {
        n();
      });
    }
  ];
}
// @__NO_SIDE_EFFECTS__
function Vi(e, t) {
  t || (t = {});
  const {
    textColor: n,
    bgColor: r,
    shouldLog: s
  } = t, o = s === void 0 ? !0 : s, a = typeof o == "boolean" ? () => o : o;
  function i(u, c, ...l) {
    if (c || a()) {
      const p = "font-weight:bold;padding:0 5px;border-radius:5px";
      console[u](
        `%c${Intl.DateTimeFormat("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          fractionalSecondDigits: 3,
          timeZone: "UTC"
        }).format(/* @__PURE__ */ new Date())}%c / %c${e}`,
        `${p};background-color: lightblue;color:black`,
        "",
        `${p};${n ? `color:${n};` : ""}${r ? `background-color:${r}` : ""}`,
        ...l
      );
    }
  }
  return [i.bind(void 0, "log"), i.bind(void 0, "error")];
}
function Li() {
  return performance.getEntriesByType("navigation")[0];
}
function z() {
  const e = Li();
  return !!e && e.type === "reload";
}
let ye;
function Ri(e, t) {
  ye && ye.set(e, t) || t();
}
function Ut(e) {
  if (ye)
    return e();
  ye = /* @__PURE__ */ new Map();
  try {
    e();
  } finally {
    ye.forEach((t) => t()), ye = void 0;
  }
}
// @__NO_SIDE_EFFECTS__
function As(e, t) {
  t || (t = {});
  const n = t.equals || Object.is;
  let r = [], s = e;
  const o = (c) => {
    if (!n(s, c)) {
      const l = s;
      s = c, Ri(u, () => {
        [...r].forEach(([p, m]) => {
          p(c, l), m && i(p, !0);
        });
      });
    }
  };
  function a(c) {
    const l = typeof c != "object" ? { once: c } : c;
    return {
      once: l.once || !1,
      signal: l.signal || !1
    };
  }
  const i = (c, l) => {
    const p = a(l), m = r.findIndex(([f, A]) => f === c && A.once === p.once && A.signal === p.signal);
    m >= 0 && r.splice(m, 1);
  }, u = Object.assign(
    function() {
      return Hi(u), s;
    },
    {
      destroy() {
        r = [];
      },
      set: o,
      reset() {
        o(e);
      },
      sub(c, l) {
        return r.push([c, a(l)]), () => i(c, l);
      },
      unsub: i,
      unsubAll() {
        r = r.filter((c) => c[1].signal);
      }
    }
  );
  return u;
}
const Oe = [];
function Hi(e) {
  Oe.length && Oe[Oe.length - 1].add(e);
}
// @__NO_SIDE_EFFECTS__
function Fi(e, t) {
  let n = /* @__PURE__ */ new Set(), r;
  function s() {
    return r || (r = /* @__PURE__ */ As(a(), t));
  }
  function o() {
    s().set(a());
  }
  function a() {
    n.forEach((c) => {
      c.unsub(o, { signal: !0 });
    });
    const i = /* @__PURE__ */ new Set();
    let u;
    Oe.push(i);
    try {
      u = e();
    } finally {
      Oe.pop();
    }
    return i.forEach((c) => {
      c.sub(o, { signal: !0 });
    }), n = i, u;
  }
  return Object.assign(function() {
    return s()();
  }, {
    destroy() {
      s().destroy();
    },
    sub(...i) {
      return s().sub(...i);
    },
    unsub(...i) {
      s().unsub(...i);
    },
    unsubAll(...i) {
      s().unsubAll(...i);
    }
  });
}
// @__NO_SIDE_EFFECTS__
function Ce(e, t) {
  return /* @__PURE__ */ As(e, t);
}
// @__NO_SIDE_EFFECTS__
function h(e, t) {
  return /* @__PURE__ */ Fi(e, t);
}
// @__NO_SIDE_EFFECTS__
function b(e, t) {
  const n = /* @__PURE__ */ Ce(e, t);
  return [n, /* @__PURE__ */ h(n)];
}
let Ms = !1;
const [zt, Af] = /* @__PURE__ */ Vi("SDK", {
  bgColor: "forestgreen",
  textColor: "white",
  shouldLog() {
    return Ms;
  }
});
function Mf(e) {
  Ms = e, gi(e);
}
const kt = /* @__PURE__ */ Ce(0), Ps = /* @__PURE__ */ Ce(hn), [Cr, gn] = /* @__PURE__ */ b({
  tgWebAppPlatform: "unknown",
  tgWebAppVersion: "0.0"
}), se = /* @__PURE__ */ h(() => gn().tgWebAppVersion);
function Wi(e) {
  e || (e = {});
  const { postEvent: t } = e, n = e.launchParams || bn();
  Cr.set(n), Ps.set(
    typeof t == "function" ? t : qi(n.tgWebAppVersion)
  ), zt(!1, "The package was configured. Launch params:", Cr());
}
function xs() {
  return kt.set(kt() + 1), kt().toString();
}
function ke(e, t, n) {
  return Di(e, t, xs(), {
    ...n || {},
    postEvent: _
  });
}
const S = (e, t, n) => (n || (n = {}), n.postEvent || (n.postEvent = _), _n(e, t, n)), _ = (e, t) => Ps()(e, t);
function G(e) {
  return /* @__PURE__ */ h(() => de(e, se()));
}
function Ui(e) {
  return (t) => t instanceof e;
}
function Y(e, t) {
  t || (t = []);
  class n extends Error {
    constructor(...s) {
      const o = typeof t == "function" ? t(...s) : typeof t == "string" ? [t] : t || [];
      super(...o), this.name = e;
    }
  }
  return Object.defineProperty(n, "name", { value: e }), [n, Ui(n)];
}
function fe(e) {
  return [e];
}
const [
  vn,
  Pf
] = Y("CSSVarsBoundError", "CSS variables are already bound"), [
  Ts,
  xf
] = Y("NotAvailableError", fe), [
  Tf,
  Bf
] = Y("InvalidEnvError", fe), [
  Pe,
  Of
] = Y("FunctionNotAvailableError", fe), [
  J,
  If
] = Y(
  "InvalidArgumentsError",
  (e, t) => [e, { cause: t }]
), [
  zi,
  jf
] = Y("ConcurrentCallError", fe), [
  Gi,
  qf
] = Y(
  "SetEmojiStatusError",
  (e) => [`Failed to set emoji status: ${e}`]
), [
  Bs,
  Df
] = Y("AccessDeniedError", fe), [
  Qi,
  Nf
] = Y("FullscreenFailedError", fe), [
  Ji,
  Vf
] = Y("ShareMessageError", fe);
function kr() {
  return typeof window > "u";
}
// @__NO_SIDE_EFFECTS__
function C(e, t, n) {
  n || (n = {});
  const {
    isSupported: r,
    isMounted: s,
    isMounting: o,
    component: a,
    supports: i
  } = n || {}, u = `${a ? `${a}.` : ""}${e}()`, c = r ? Array.isArray(r) || typeof r == "object" && "any" in r ? r : [r] : void 0;
  function l(E) {
    if (i) {
      const $ = i[E];
      return de($[0], $[1], se());
    }
    return !0;
  }
  function p() {
    if (!c)
      return;
    function E(V) {
      return typeof V == "function" ? V() : de(V, se()) ? void 0 : `it is unsupported in Mini Apps version ${se()}`;
    }
    const $ = Array.isArray(c) ? c : c.any, I = $.map(E).filter(Boolean);
    return Array.isArray(c) ? I[0] : I.length === $.length ? I[I.length - 1] : void 0;
  }
  function m(...E) {
    for (const $ in i)
      if (i[$][2](...E) && !l($))
        return `option ${$} is not supported in Mini Apps version ${se()}`;
  }
  let f;
  if (i) {
    f = {};
    for (const E in i)
      f[E] = /* @__PURE__ */ h(() => l(E));
  }
  const A = /* @__PURE__ */ h(() => !p()), be = /* @__PURE__ */ h(() => se() !== "0.0"), M = /* @__PURE__ */ h(() => !s || s()), ne = /* @__PURE__ */ h(
    () => $r() && !kr() && be() && A() && M()
  );
  return Object.assign(
    (...E) => {
      const $ = `Unable to call the ${u} ${a ? "method" : "function"}:`;
      if (kr() || !$r())
        throw new Pe(`${$} it can't be called outside Mini Apps`);
      if (!be())
        throw new Pe(`${$} the SDK was not initialized. Use the SDK init() function`);
      const I = p();
      if (I)
        throw new Pe(`${$} ${I}`);
      const V = m(...E);
      if (V)
        throw new Pe(`${$} ${V}`);
      if (!M()) {
        const d = o && o() ? "mounting. Wait for the mount completion" : `unmounted. Use the ${a}.mount() method`;
        throw new Pe(`${$} the component is ${d}`);
      }
      return t(...E);
    },
    t,
    {
      isAvailable: ne,
      ifAvailable(...E) {
        return ne() ? [!0, t(...E)] : [!1];
      }
    },
    c ? { isSupported: A } : {},
    f ? { supports: f } : {}
  );
}
function nt(e, t) {
  return t || (t = {}), (n, r, s, o) => /* @__PURE__ */ C(n, r, {
    ...t,
    isSupported: s || t.isSupported,
    supports: o,
    component: e
  });
}
function ce(e, t, n) {
  return nt(e, { isSupported: n, isMounted: t });
}
function N(e, t) {
  return nt(e, { isSupported: t });
}
const rt = "web_app_setup_back_button", Os = "back_button_pressed", st = "backButton", [Ar, Ki] = /* @__PURE__ */ b(!1), [Ge, Yi] = /* @__PURE__ */ b(!1), Zi = G(rt), Is = ce(st, Ge, rt), wn = N(st, rt), Xi = Is("hide", () => {
  En(!1);
}), eu = wn("mount", () => {
  Ge() || (En(z() && U(st) || !1), Ge.set(!0));
});
function En(e) {
  e !== Ar() && (_(rt, { is_visible: e }), W(st, e), Ar.set(e));
}
const tu = wn(
  "onClick",
  (e) => k(Os, e)
), nu = wn(
  "offClick",
  (e) => {
    B(Os, e);
  }
), ru = Is("show", () => {
  En(!0);
});
function su() {
  Ge.set(!1);
}
const Lf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hide: Xi,
  isMounted: Yi,
  isSupported: Zi,
  isVisible: Ki,
  mount: eu,
  offClick: nu,
  onClick: tu,
  show: ru,
  unmount: su
}, Symbol.toStringTag, { value: "Module" }));
var ou = Object.defineProperty, au = (e, t, n) => t in e ? ou(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Gt = (e, t, n) => au(e, typeof t != "symbol" ? t + "" : t, n);
function iu(e) {
  return (t) => t instanceof e;
}
function js(e, t) {
  t || (t = []);
  class n extends Error {
    constructor(...s) {
      const o = typeof t == "function" ? t(...s) : typeof t == "string" ? [t] : t || [];
      super(...o), this.name = e;
    }
  }
  return Object.defineProperty(n, "name", { value: e }), [n, iu(n)];
}
const [uu, cu] = js("CancelledError", "Promise was canceled"), [lu, Rf] = js(
  "TimeoutError",
  (e, t) => [`Timeout reached: ${e}ms`, { cause: t }]
), qs = Symbol("Resolved");
function Mr(e) {
  return Array.isArray(e) && e[0] === qs;
}
function pu(e) {
  return [qs, e];
}
function Pr(e, t) {
  return e.reject = t.reject, e.abort = t.abort, e;
}
let x = class Qt extends Promise {
  constructor(t, n) {
    let r, s;
    super((o, a) => {
      let i, u;
      typeof t == "function" ? (i = t, u = n) : u = t;
      const c = [], l = (d) => (...j) => {
        const ee = d(...j);
        return c.forEach(($t) => $t()), ee;
      }, p = new AbortController(), { signal: m } = p;
      s = (d) => {
        !m.aborted && p.abort(d);
      };
      const f = () => m.reason, A = (d) => {
        const j = () => {
          d(f());
        };
        m.addEventListener("abort", j, !0);
        const ee = () => {
          m.removeEventListener("abort", j, !0);
        };
        return c.push(ee), ee;
      }, be = l((d) => {
        o(d), s(pu(d));
      });
      r = l((d) => {
        a(d), s(d);
      }), u || (u = {});
      const { abortSignal: M, rejectOnAbort: ne = !0 } = u;
      if (M)
        if (M.aborted) {
          const { reason: d } = M;
          if (ne)
            return r(d);
          s(d);
        } else {
          const d = () => {
            s(M.reason);
          };
          M.addEventListener("abort", d), c.push(() => {
            M.removeEventListener("abort", d);
          });
        }
      ne && A(a);
      const { timeout: E } = u;
      if (E) {
        const d = setTimeout(() => {
          s(new lu(E));
        }, E);
        c.push(() => {
          clearTimeout(d);
        });
      }
      const $ = () => m.aborted, I = () => Mr(f()), V = () => {
        const d = f();
        return Mr(d) ? d[1] : void 0;
      };
      try {
        const d = i && i(be, r, {
          abortReason: f,
          abortSignal: m,
          isAborted: $,
          isResolved: I,
          onAborted: A,
          onResolved: (j) => A(() => {
            I() && j(V());
          }),
          resolved: V,
          throwIfAborted() {
            if ($())
              throw f();
          }
        });
        d instanceof Promise && d.catch(r);
      } catch (d) {
        r(d);
      }
    }), Gt(this, "abort"), Gt(this, "reject"), this.abort = s, this.reject = r;
  }
  /**
   * Creates a new AbortablePromise instance using an executor, resolving the promise when a result
   * was returned.
   * @param fn - function returning promise result.
   * @param options - additional options.
   */
  static fn(t, n) {
    return new Qt(async (r, s, o) => {
      try {
        r(await t(o));
      } catch (a) {
        s(a);
      }
    }, n);
  }
  static resolve(t) {
    return this.fn(() => t);
  }
  /**
   * @see Promise.reject
   */
  static reject(t) {
    return new Qt((n, r) => {
      r(t);
    });
  }
  /**
   * Aborts the promise with the cancel error.
   */
  cancel() {
    this.abort(new uu());
  }
  /**
   * @see Promise.catch
   */
  catch(t) {
    return this.then(void 0, t);
  }
  /**
   * @see Promise.finally
   */
  finally(t) {
    return Pr(super.finally(t), this);
  }
  /**
   * @see Promise.then
   */
  then(t, n) {
    return Pr(super.then(t, n), this);
  }
};
function xr(e, t) {
  return e.resolve = t.resolve, e;
}
let du = class Jt extends x {
  constructor(t, n) {
    let r, s;
    typeof t == "function" ? (r = t, s = n) : s = t;
    let o;
    super((a, i, u) => {
      o = a, r && r(a, i, u);
    }, s), Gt(this, "resolve"), this.resolve = o;
  }
  /**
   * Creates a new ManualPromise instance using an executor, resolving the promise when a result
   * was returned.
   * @param fn - function returning promise result.
   * @param options - additional options.
   */
  static fn(t, n) {
    return new Jt((r, s, o) => {
      try {
        Promise.resolve(t(o)).then(r, s);
      } catch (a) {
        s(a);
      }
    }, n);
  }
  static resolve(t) {
    return this.fn(() => t);
  }
  /**
   * @see Promise.reject
   */
  static reject(t) {
    return new Jt((n, r) => {
      r(t);
    });
  }
  /**
   * @see Promise.catch
   */
  catch(t) {
    return this.then(void 0, t);
  }
  /**
   * @see Promise.finally
   */
  finally(t) {
    return xr(super.finally(t), this);
  }
  /**
   * @see Promise.then
   */
  then(t, n) {
    return xr(super.then(t, n), this);
  }
};
function O(e, t, n) {
  n || (n = {});
  const {
    promise: r,
    error: s
  } = n, [o, a] = r ? [r, /* @__PURE__ */ h(r)] : /* @__PURE__ */ b(), [i, u] = s ? [s, /* @__PURE__ */ h(s)] : /* @__PURE__ */ b();
  return [
    Object.assign((...c) => {
      if (o()) {
        const p = new zi(t);
        return i.set(p), x.reject(p);
      }
      Ut(() => {
        o.set(e(...c)), i.set(void 0);
      });
      let l;
      return o().catch((p) => {
        throw l = p, p;
      }).finally(() => {
        Ut(() => {
          o.set(void 0), i.set(l);
        });
      });
    }, e),
    [o, a, /* @__PURE__ */ h(() => !!o())],
    [i, u]
  ];
}
// @__NO_SIDE_EFFECTS__
function Le(e, t, n) {
  const [r, ...s] = O(t, `The ${e} component is already mounting`), [o, a] = /* @__PURE__ */ b(!1);
  return [
    (...i) => o() ? x.resolve() : r(...i).then((u) => {
      Ut(() => {
        o.set(!0), n(u);
      });
    }),
    ...s,
    [o, a]
  ];
}
const [$n, fu] = /* @__PURE__ */ b({
  available: !1,
  type: "",
  accessGranted: !1,
  accessRequested: !1,
  deviceId: "",
  tokenSaved: !1
}), mu = /* @__PURE__ */ h(() => $n().available), Tr = "web_app_biometry_get_info", hu = /* @__PURE__ */ C(
  "requestBiometry",
  (e) => S(Tr, "biometry_info_received", e),
  { isSupported: Tr }
);
function Ds(e) {
  if (!cu(e))
    throw e;
}
function Ae(e) {
  const t = e();
  t && t.catch(Ds).cancel();
}
const De = "biometry", ot = "web_app_biometry_request_auth", Sn = "biometry_info_received", Ns = (e) => {
  at(Cn(e));
};
function Vs() {
  throw new Ts("Biometry is not available");
}
function Cn(e) {
  let t = !1, n = !1, r = "", s = !1, o = "", a = !1;
  return e.available && (t = !0, n = e.token_saved, r = e.device_id, s = e.access_requested, o = e.type, a = e.access_granted), { available: t, tokenSaved: n, deviceId: r, type: o, accessGranted: a, accessRequested: s };
}
const _u = G(ot), [
  bu,
  yu,
  gu,
  Ls
] = /* @__PURE__ */ Le(
  De,
  (e) => {
    const t = z() && U(De);
    return t ? x.resolve(t) : hu({ abortSignal: e }).then(Cn);
  },
  (e) => {
    k(Sn, Ns), at(e);
  }
), Rs = N(De, ot), kn = ce(De, Ls[0], ot), vu = Rs("mount", bu), [, Hs, wu] = yu, [, Eu] = gu, [$u, Su] = Ls, [
  Cu,
  ku,
  Au
] = O(
  (e) => x.fn(async (t) => {
    const n = $n();
    n.available || Vs();
    const r = await S(ot, "biometry_auth_requested", {
      ...e,
      ...t,
      params: { reason: ((e || {}).reason || "").trim() }
    }), { token: s } = r;
    return typeof s == "string" && at({ ...n, token: s }), r;
  }, e),
  "Biometry authentication is already in progress"
), Mu = kn("authenticate", Cu), [, Fs, Pu] = ku, [, xu] = Au, Tu = Rs("openSettings", () => {
  _("web_app_biometry_open_settings");
}), [
  Bu,
  Ou,
  Iu
] = O(
  (e) => x.fn(async (t) => {
    const n = await S("web_app_biometry_request_access", Sn, {
      ...e,
      ...t,
      params: { reason: (e || {}).reason || "" }
    }).then(Cn);
    return n.available || Vs(), at(n), n.accessGranted;
  }, e),
  "Biometry access request is already in progress"
), ju = kn("requestAccess", Bu), [, Ws, qu] = Ou, [, Du] = Iu;
function at(e) {
  $n.set(e), W(De, e);
}
function Nu() {
  [Fs, Ws, Hs].forEach(Ae), B(Sn, Ns), $u.set(!1);
}
const Vu = kn(
  "updateToken",
  (e) => (e || (e = {}), S("web_app_biometry_update_token", "biometry_token_updated", {
    ...e,
    params: {
      token: e.token || "",
      reason: e.reason
    }
  }).then((t) => t.status))
), Hf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  authError: xu,
  authPromise: Fs,
  authenticate: Mu,
  isAuthenticating: Pu,
  isAvailable: mu,
  isMounted: Su,
  isMounting: wu,
  isRequestingAccess: qu,
  isSupported: _u,
  mount: vu,
  mountError: Eu,
  mountPromise: Hs,
  openSettings: Tu,
  requestAccess: ju,
  requestAccessError: Du,
  requestAccessPromise: Ws,
  state: fu,
  unmount: Nu,
  updateToken: Vu
}, Symbol.toStringTag, { value: "Module" }));
function it(e, t) {
  return nt(e, { isMounted: t });
}
const le = nt, ut = "closingBehavior", [Br, Lu] = /* @__PURE__ */ b(!1), [Kt, Us] = /* @__PURE__ */ b(!1), zs = it(ut, Us), Ru = le(ut), Hu = zs("disableConfirmation", () => {
  An(!1);
}), Fu = zs("enableConfirmation", () => {
  An(!0);
}), Wu = Ru("mount", () => {
  Kt() || (An(
    z() && U(ut) || !1
  ), Kt.set(!0));
});
function An(e) {
  e !== Br() && (_("web_app_setup_closing_behavior", { need_confirmation: e }), W(ut, e), Br.set(e));
}
function Uu() {
  Kt.set(!1);
}
const Ff = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  disableConfirmation: Hu,
  enableConfirmation: Fu,
  isConfirmationEnabled: Lu,
  isMounted: Us,
  mount: Wu,
  unmount: Uu
}, Symbol.toStringTag, { value: "Module" }));
var te;
// @__NO_SIDE_EFFECTS__
function Gs(e) {
  return {
    lang: (e == null ? void 0 : e.lang) ?? (te == null ? void 0 : te.lang),
    message: e == null ? void 0 : e.message,
    abortEarly: (e == null ? void 0 : e.abortEarly) ?? (te == null ? void 0 : te.abortEarly),
    abortPipeEarly: (e == null ? void 0 : e.abortPipeEarly) ?? (te == null ? void 0 : te.abortPipeEarly)
  };
}
var At;
// @__NO_SIDE_EFFECTS__
function zu(e) {
  return At == null ? void 0 : At.get(e);
}
var Mt;
// @__NO_SIDE_EFFECTS__
function Gu(e) {
  return Mt == null ? void 0 : Mt.get(e);
}
var Pt;
// @__NO_SIDE_EFFECTS__
function Qu(e, t) {
  var n;
  return (n = Pt == null ? void 0 : Pt.get(e)) == null ? void 0 : n.get(t);
}
// @__NO_SIDE_EFFECTS__
function Ju(e) {
  var n, r;
  const t = typeof e;
  return t === "string" ? `"${e}"` : t === "number" || t === "bigint" || t === "boolean" ? `${e}` : t === "object" || t === "function" ? (e && ((r = (n = Object.getPrototypeOf(e)) == null ? void 0 : n.constructor) == null ? void 0 : r.name)) ?? "null" : t;
}
function L(e, t, n, r, s) {
  const o = s && "input" in s ? s.input : n.value, a = (s == null ? void 0 : s.expected) ?? e.expects ?? null, i = (s == null ? void 0 : s.received) ?? /* @__PURE__ */ Ju(o), u = {
    kind: e.kind,
    type: e.type,
    input: o,
    expected: a,
    received: i,
    message: `Invalid ${t}: ${a ? `Expected ${a} but r` : "R"}eceived ${i}`,
    requirement: e.requirement,
    path: s == null ? void 0 : s.path,
    issues: s == null ? void 0 : s.issues,
    lang: r.lang,
    abortEarly: r.abortEarly,
    abortPipeEarly: r.abortPipeEarly
  }, c = e.kind === "schema", l = (s == null ? void 0 : s.message) ?? e.message ?? /* @__PURE__ */ Qu(e.reference, u.lang) ?? (c ? /* @__PURE__ */ Gu(u.lang) : null) ?? r.message ?? /* @__PURE__ */ zu(u.lang);
  l && (u.message = typeof l == "function" ? (
    // @ts-expect-error
    l(u)
  ) : l), c && (n.typed = !1), n.issues ? n.issues.push(u) : n.issues = [u];
}
// @__NO_SIDE_EFFECTS__
function Z(e) {
  return {
    version: 1,
    vendor: "valibot",
    validate(t) {
      return e["~run"]({ value: t }, /* @__PURE__ */ Gs());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Qs(e, t) {
  return Object.hasOwn(e, t) && t !== "__proto__" && t !== "prototype" && t !== "constructor";
}
// @__NO_SIDE_EFFECTS__
function Ku(e, t) {
  const n = [...new Set(e)];
  return n.length > 1 ? `(${n.join(` ${t} `)})` : n[0] ?? "never";
}
var Yt = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(e) {
    super(e[0].message), this.name = "ValiError", this.issues = e;
  }
};
// @__NO_SIDE_EFFECTS__
function Js(e) {
  return {
    kind: "validation",
    type: "integer",
    reference: Js,
    async: !1,
    expects: null,
    requirement: Number.isInteger,
    message: e,
    "~run"(t, n) {
      return t.typed && !this.requirement(t.value) && L(this, "integer", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Mn(e) {
  return {
    kind: "transformation",
    type: "transform",
    reference: Mn,
    async: !1,
    operation: e,
    "~run"(t) {
      return t.value = this.operation(t.value), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ks(e, t, n) {
  return typeof e.default == "function" ? (
    // @ts-expect-error
    e.default(t, n)
  ) : (
    // @ts-expect-error
    e.default
  );
}
// @__NO_SIDE_EFFECTS__
function Ys(e, t) {
  return {
    kind: "schema",
    type: "array",
    reference: Ys,
    expects: "Array",
    async: !1,
    item: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ Z(this);
    },
    "~run"(n, r) {
      var o;
      const s = n.value;
      if (Array.isArray(s)) {
        n.typed = !0, n.value = [];
        for (let a = 0; a < s.length; a++) {
          const i = s[a], u = this.item["~run"]({ value: i }, r);
          if (u.issues) {
            const c = {
              type: "array",
              origin: "value",
              input: s,
              key: a,
              value: i
            };
            for (const l of u.issues)
              l.path ? l.path.unshift(c) : l.path = [c], (o = n.issues) == null || o.push(l);
            if (n.issues || (n.issues = u.issues), r.abortEarly) {
              n.typed = !1;
              break;
            }
          }
          u.typed || (n.typed = !1), n.value.push(u.value);
        }
      } else
        L(this, "type", n, r);
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Pn(e) {
  return {
    kind: "schema",
    type: "date",
    reference: Pn,
    expects: "Date",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ Z(this);
    },
    "~run"(t, n) {
      return t.value instanceof Date ? isNaN(t.value) ? L(this, "type", t, n, {
        received: '"Invalid Date"'
      }) : t.typed = !0 : L(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Zs(e, t) {
  return {
    kind: "schema",
    type: "instance",
    reference: Zs,
    expects: e.name,
    async: !1,
    class: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ Z(this);
    },
    "~run"(n, r) {
      return n.value instanceof this.class ? n.typed = !0 : L(this, "type", n, r), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Zt(e, t) {
  return {
    kind: "schema",
    type: "loose_object",
    reference: Zt,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ Z(this);
    },
    "~run"(n, r) {
      var o;
      const s = n.value;
      if (s && typeof s == "object") {
        n.typed = !0, n.value = {};
        for (const a in this.entries) {
          const i = this.entries[a];
          if (a in s || (i.type === "exact_optional" || i.type === "optional" || i.type === "nullish") && // @ts-expect-error
          i.default !== void 0) {
            const u = a in s ? (
              // @ts-expect-error
              s[a]
            ) : /* @__PURE__ */ Ks(i), c = i["~run"]({ value: u }, r);
            if (c.issues) {
              const l = {
                type: "object",
                origin: "value",
                input: s,
                key: a,
                value: u
              };
              for (const p of c.issues)
                p.path ? p.path.unshift(l) : p.path = [l], (o = n.issues) == null || o.push(p);
              if (n.issues || (n.issues = c.issues), r.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            c.typed || (n.typed = !1), n.value[a] = c.value;
          } else if (i.type !== "exact_optional" && i.type !== "optional" && i.type !== "nullish" && (L(this, "key", n, r, {
            input: void 0,
            expected: `"${a}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: s,
                key: a,
                // @ts-expect-error
                value: s[a]
              }
            ]
          }), r.abortEarly))
            break;
        }
        if (!n.issues || !r.abortEarly)
          for (const a in s)
            /* @__PURE__ */ Qs(s, a) && !(a in this.entries) && (n.value[a] = s[a]);
      } else
        L(this, "type", n, r);
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function xn(e) {
  return {
    kind: "schema",
    type: "number",
    reference: xn,
    expects: "number",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ Z(this);
    },
    "~run"(t, n) {
      return typeof t.value == "number" && !isNaN(t.value) ? t.typed = !0 : L(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Xs(e, t) {
  return {
    kind: "schema",
    type: "optional",
    reference: Xs,
    expects: `(${e.expects} | undefined)`,
    async: !1,
    wrapped: e,
    default: t,
    get "~standard"() {
      return /* @__PURE__ */ Z(this);
    },
    "~run"(n, r) {
      return n.value === void 0 && (this.default !== void 0 && (n.value = /* @__PURE__ */ Ks(this, n, r)), n.value === void 0) ? (n.typed = !0, n) : this.wrapped["~run"](n, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function eo(e, t, n) {
  return {
    kind: "schema",
    type: "record",
    reference: eo,
    expects: "Object",
    async: !1,
    key: e,
    value: t,
    message: n,
    get "~standard"() {
      return /* @__PURE__ */ Z(this);
    },
    "~run"(r, s) {
      var a, i;
      const o = r.value;
      if (o && typeof o == "object") {
        r.typed = !0, r.value = {};
        for (const u in o)
          if (/* @__PURE__ */ Qs(o, u)) {
            const c = o[u], l = this.key["~run"]({ value: u }, s);
            if (l.issues) {
              const m = {
                type: "object",
                origin: "key",
                input: o,
                key: u,
                value: c
              };
              for (const f of l.issues)
                f.path = [m], (a = r.issues) == null || a.push(f);
              if (r.issues || (r.issues = l.issues), s.abortEarly) {
                r.typed = !1;
                break;
              }
            }
            const p = this.value["~run"](
              { value: c },
              s
            );
            if (p.issues) {
              const m = {
                type: "object",
                origin: "value",
                input: o,
                key: u,
                value: c
              };
              for (const f of p.issues)
                f.path ? f.path.unshift(m) : f.path = [m], (i = r.issues) == null || i.push(f);
              if (r.issues || (r.issues = p.issues), s.abortEarly) {
                r.typed = !1;
                break;
              }
            }
            (!l.typed || !p.typed) && (r.typed = !1), l.typed && (r.value[l.value] = p.value);
          }
      } else
        L(this, "type", r, s);
      return r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function H(e) {
  return {
    kind: "schema",
    type: "string",
    reference: H,
    expects: "string",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ Z(this);
    },
    "~run"(t, n) {
      return typeof t.value == "string" ? t.typed = !0 : L(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Or(e) {
  let t;
  if (e)
    for (const n of e)
      t ? t.push(...n.issues) : t = n.issues;
  return t;
}
// @__NO_SIDE_EFFECTS__
function to(e, t) {
  return {
    kind: "schema",
    type: "union",
    reference: to,
    expects: /* @__PURE__ */ Ku(
      e.map((n) => n.expects),
      "|"
    ),
    async: !1,
    options: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ Z(this);
    },
    "~run"(n, r) {
      let s, o, a;
      for (const i of this.options) {
        const u = i["~run"]({ value: n.value }, r);
        if (u.typed)
          if (u.issues)
            o ? o.push(u) : o = [u];
          else {
            s = u;
            break;
          }
        else
          a ? a.push(u) : a = [u];
      }
      if (s)
        return s;
      if (o) {
        if (o.length === 1)
          return o[0];
        L(this, "type", n, r, {
          issues: /* @__PURE__ */ Or(o)
        }), n.typed = !0;
      } else {
        if ((a == null ? void 0 : a.length) === 1)
          return a[0];
        L(this, "type", n, r, {
          issues: /* @__PURE__ */ Or(a)
        });
      }
      return n;
    }
  };
}
function ct(e, t, n) {
  const r = e["~run"]({ value: t }, /* @__PURE__ */ Gs(n));
  if (r.issues)
    throw new Yt(r.issues);
  return r.value;
}
// @__NO_SIDE_EFFECTS__
function Ue(...e) {
  return {
    ...e[0],
    pipe: e,
    get "~standard"() {
      return /* @__PURE__ */ Z(this);
    },
    "~run"(t, n) {
      for (const r of e)
        if (r.kind !== "metadata") {
          if (t.issues && (r.kind === "schema" || r.kind === "transformation")) {
            t.typed = !1;
            break;
          }
          (!t.issues || !n.abortEarly && !n.abortPipeEarly) && (t = r["~run"](t, n));
        }
      return t;
    }
  };
}
const no = "web_app_invoke_custom_method", Re = N("cloudStorage", no), Yu = G(no), ro = Re("deleteItem", (e, t) => {
  const n = Array.isArray(e) ? e : [e];
  return n.length ? ke("deleteStorageValues", { keys: n }, t).then() : x.resolve();
});
function Zu(e, t) {
  const n = Array.isArray(e) ? e : [e];
  return n.length ? ke("getStorageValues", { keys: n }, t).then((r) => {
    const s = {
      // Fulfill the response with probably missing keys.
      ...n.reduce((o, a) => (o[a] = "", o), {}),
      ...ct(/* @__PURE__ */ eo(/* @__PURE__ */ H(), /* @__PURE__ */ H()), r)
    };
    return typeof e == "string" ? s[e] : s;
  }) : x.resolve(Array.isArray(e) ? {} : "");
}
const Xu = Re("getItem", Zu), so = Re("getKeys", (e) => ke("getStorageKeys", {}, e).then(
  (t) => ct(/* @__PURE__ */ Ys(/* @__PURE__ */ H()), t)
)), ec = Re("setItem", (e, t, n) => ke("saveStorageValue", {
  key: e,
  value: t
}, n).then()), tc = Re("clear", (e) => so(e).then(ro)), Wf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clear: tc,
  deleteItem: ro,
  getItem: Xu,
  getKeys: so,
  isSupported: Yu,
  setItem: ec
}, Symbol.toStringTag, { value: "Module" })), He = "web_app_trigger_haptic_feedback", Tn = N("hapticFeedback", He), nc = G(He), rc = Tn(
  "impactOccurred",
  (e) => {
    _(He, {
      type: "impact",
      impact_style: e
    });
  }
), sc = Tn(
  "notificationOccurred",
  (e) => {
    _(He, {
      type: "notification",
      notification_type: e
    });
  }
), oc = Tn(
  "selectionChanged",
  () => {
    _(He, { type: "selection_change" });
  }
), Uf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  impactOccurred: rc,
  isSupported: nc,
  notificationOccurred: sc,
  selectionChanged: oc
}, Symbol.toStringTag, { value: "Module" })), [oo, ac] = /* @__PURE__ */ b(void 0);
function X(e) {
  return /* @__PURE__ */ h(() => {
    const t = oo();
    return t ? t[e] : void 0;
  });
}
const ao = X("auth_date"), io = X("can_send_after"), ic = /* @__PURE__ */ h(() => {
  const e = ao(), t = io();
  return t && e ? new Date(e.getTime() + t * 1e3) : void 0;
}), uc = X("chat"), cc = X("chat_type"), lc = X("chat_instance"), pc = X("hash"), dc = X("query_id"), [fc, mc] = /* @__PURE__ */ b(), hc = X("receiver");
function _c() {
  const e = bn();
  oo.set(e.tgWebAppData), fc.set(Ii());
}
const bc = X("start_param"), yc = X("user"), zf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  authDate: ao,
  canSendAfter: io,
  canSendAfterDate: ic,
  chat: uc,
  chatInstance: lc,
  chatType: cc,
  hash: pc,
  queryId: dc,
  raw: mc,
  receiver: hc,
  restore: _c,
  startParam: bc,
  state: ac,
  user: yc
}, Symbol.toStringTag, { value: "Module" })), Bn = "web_app_open_invoice", gc = N("invoice", Bn), vc = G(Bn);
function wc(e, t, n) {
  let r;
  if (t === "url") {
    const { hostname: s, pathname: o } = new URL(e, window.location.href);
    if (s !== "t.me")
      throw new J(`Link has unexpected hostname: ${s}`);
    const a = o.match(/^\/(\$|invoice\/)([A-Za-z0-9\-_=]+)$/);
    if (!a)
      throw new J(
        'Expected to receive a link with a pathname in format "/invoice/{slug}" or "/${slug}"'
      );
    [, , r] = a;
  } else
    r = e, n = t;
  return S(Bn, "invoice_closed", {
    ...n,
    params: { slug: r },
    capture: (s) => r === s.slug
  }).then((s) => s.status);
}
const [
  Ec,
  $c,
  Sc
] = O(wc, "Invoice is already opened"), Cc = gc("open", Ec), [, kc, Ac] = $c, [, Mc] = Sc, Gf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isOpened: Ac,
  isSupported: vc,
  open: Cc,
  openError: Mc,
  openPromise: kc
}, Symbol.toStringTag, { value: "Module" })), Ie = "locationManager", On = "web_app_check_location", Ir = "web_app_open_location_settings", Qe = /* @__PURE__ */ Ce({
  available: !1,
  accessGranted: !1,
  accessRequested: !1
});
function In(e) {
  return /* @__PURE__ */ h(() => Qe()[e]);
}
const Pc = G(On), xc = In("available"), Tc = In("accessGranted"), Bc = In("accessRequested");
function Oc(e) {
  let t = !1, n, r;
  return e.available && (t = !0, n = e.access_requested, r = e.access_granted), {
    available: t,
    accessGranted: r || !1,
    accessRequested: n || !1
  };
}
const [
  Ic,
  jc,
  qc,
  uo
] = /* @__PURE__ */ Le(
  Ie,
  (e) => {
    const t = z() && U(Ie);
    return t ? x.resolve(t) : S("web_app_check_location", "location_checked", e).then(Oc);
  },
  (e) => {
    Qe.set(e), W(Ie, e);
  }
), co = N(Ie, On), Dc = ce(Ie, uo[0], On), Nc = co("mount", Ic), [, Vc, Lc] = jc, [, Rc] = qc, [Hc, Fc] = uo, [
  Wc,
  Uc,
  zc
] = O(
  (e) => S("web_app_request_location", "location_requested", e).then((t) => {
    if (!t.available)
      throw Qe.set({ ...Qe(), available: !1 }), new Ts("Location data tracking is not available");
    const { available: n, ...r } = t;
    return r;
  }),
  "Location request is currently in progress"
), Gc = Dc("requestLocation", Wc), [, lo, Qc] = Uc, [, Jc] = zc, Kc = co("openSettings", () => {
  _(Ir);
}, Ir);
function Yc() {
  Ae(lo), Hc.set(!1);
}
const Qf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isAccessGranted: Tc,
  isAccessRequested: Bc,
  isAvailable: xc,
  isMounted: Fc,
  isMounting: Lc,
  isRequestingLocation: Qc,
  isSupported: Pc,
  mount: Nc,
  mountError: Rc,
  mountPromise: Vc,
  openSettings: Kc,
  requestLocation: Gc,
  requestLocationError: Jc,
  requestLocationPromise: lo,
  unmount: Yc
}, Symbol.toStringTag, { value: "Module" }));
function jn(e) {
  const t = {};
  for (const n in e) {
    const r = e[n];
    r !== void 0 && (t[n] = r);
  }
  return t;
}
// @__NO_SIDE_EFFECTS__
function po(e) {
  return {
    lang: (e == null ? void 0 : e.lang) ?? void 0,
    message: e == null ? void 0 : e.message,
    abortEarly: (e == null ? void 0 : e.abortEarly) ?? void 0,
    abortPipeEarly: (e == null ? void 0 : e.abortPipeEarly) ?? void 0
  };
}
// @__NO_SIDE_EFFECTS__
function Zc(e, t) {
  var n;
  return (n = void 0) == null ? void 0 : n.get(t);
}
// @__NO_SIDE_EFFECTS__
function Xc(e) {
  var t, n;
  const r = typeof e;
  return r === "string" ? `"${e}"` : r === "number" || r === "bigint" || r === "boolean" ? `${e}` : r === "object" || r === "function" ? (e && ((n = (t = Object.getPrototypeOf(e)) == null ? void 0 : t.constructor) == null ? void 0 : n.name)) ?? "null" : r;
}
function D(e, t, n, r, s) {
  const o = s && "input" in s ? s.input : n.value, a = (s == null ? void 0 : s.expected) ?? e.expects ?? null, i = (s == null ? void 0 : s.received) ?? /* @__PURE__ */ Xc(o), u = {
    kind: e.kind,
    type: e.type,
    input: o,
    expected: a,
    received: i,
    message: `Invalid ${t}: ${a ? `Expected ${a} but r` : "R"}eceived ${i}`,
    requirement: e.requirement,
    path: s == null ? void 0 : s.path,
    issues: s == null ? void 0 : s.issues,
    lang: r.lang,
    abortEarly: r.abortEarly,
    abortPipeEarly: r.abortPipeEarly
  }, c = e.kind === "schema", l = (s == null ? void 0 : s.message) ?? e.message ?? /* @__PURE__ */ Zc(e.reference, u.lang) ?? (c ? (u.lang, void 0) : null) ?? r.message ?? (u.lang, void 0);
  l && (u.message = typeof l == "function" ? (
    // @ts-expect-error
    l(u)
  ) : l), c && (n.typed = !1), n.issues ? n.issues.push(u) : n.issues = [u];
}
// @__NO_SIDE_EFFECTS__
function Q(e) {
  return {
    version: 1,
    vendor: "valibot",
    validate(t) {
      return e["~run"]({ value: t }, /* @__PURE__ */ po());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function fo(e, t) {
  return Object.hasOwn(e, t) && t !== "__proto__" && t !== "prototype" && t !== "constructor";
}
// @__NO_SIDE_EFFECTS__
function el(e, t) {
  const n = [...new Set(e)];
  return n.length > 1 ? `(${n.join(` ${t} `)})` : n[0] ?? "never";
}
var tl = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(e) {
    super(e[0].message), this.name = "ValiError", this.issues = e;
  }
};
// @__NO_SIDE_EFFECTS__
function mo(e, t) {
  return {
    kind: "validation",
    type: "check",
    reference: mo,
    async: !1,
    expects: null,
    requirement: e,
    message: t,
    "~run"(n, r) {
      return n.typed && !this.requirement(n.value) && D(this, "input", n, r), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ho(e) {
  return {
    kind: "validation",
    type: "integer",
    reference: ho,
    async: !1,
    expects: null,
    requirement: Number.isInteger,
    message: e,
    "~run"(t, n) {
      return t.typed && !this.requirement(t.value) && D(this, "integer", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ie(e) {
  return {
    kind: "transformation",
    type: "transform",
    reference: ie,
    async: !1,
    operation: e,
    "~run"(t) {
      return t.value = this.operation(t.value), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function _o(e, t, n) {
  return typeof e.default == "function" ? (
    // @ts-expect-error
    e.default(t, n)
  ) : (
    // @ts-expect-error
    e.default
  );
}
// @__NO_SIDE_EFFECTS__
function Be(e) {
  return {
    kind: "schema",
    type: "boolean",
    reference: Be,
    expects: "boolean",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ Q(this);
    },
    "~run"(t, n) {
      return typeof t.value == "boolean" ? t.typed = !0 : D(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function bo(e) {
  return {
    kind: "schema",
    type: "date",
    reference: bo,
    expects: "Date",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ Q(this);
    },
    "~run"(t, n) {
      return t.value instanceof Date ? isNaN(t.value) ? D(this, "type", t, n, {
        received: '"Invalid Date"'
      }) : t.typed = !0 : D(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function yo(e, t) {
  return {
    kind: "schema",
    type: "instance",
    reference: yo,
    expects: e.name,
    async: !1,
    class: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ Q(this);
    },
    "~run"(n, r) {
      return n.value instanceof this.class ? n.typed = !0 : D(this, "type", n, r), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function qn(e) {
  return {
    kind: "schema",
    type: "lazy",
    reference: qn,
    expects: "unknown",
    async: !1,
    getter: e,
    get "~standard"() {
      return /* @__PURE__ */ Q(this);
    },
    "~run"(t, n) {
      return this.getter(t.value)["~run"](t, n);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Fe(e, t) {
  return {
    kind: "schema",
    type: "loose_object",
    reference: Fe,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ Q(this);
    },
    "~run"(n, r) {
      var s;
      const o = n.value;
      if (o && typeof o == "object") {
        n.typed = !0, n.value = {};
        for (const a in this.entries) {
          const i = this.entries[a];
          if (a in o || (i.type === "exact_optional" || i.type === "optional" || i.type === "nullish") && // @ts-expect-error
          i.default !== void 0) {
            const u = a in o ? (
              // @ts-expect-error
              o[a]
            ) : /* @__PURE__ */ _o(i), c = i["~run"]({ value: u }, r);
            if (c.issues) {
              const l = {
                type: "object",
                origin: "value",
                input: o,
                key: a,
                value: u
              };
              for (const p of c.issues)
                p.path ? p.path.unshift(l) : p.path = [l], (s = n.issues) == null || s.push(p);
              if (n.issues || (n.issues = c.issues), r.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            c.typed || (n.typed = !1), n.value[a] = c.value;
          } else if (i.type !== "exact_optional" && i.type !== "optional" && i.type !== "nullish" && (D(this, "key", n, r, {
            input: void 0,
            expected: `"${a}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: o,
                key: a,
                // @ts-expect-error
                value: o[a]
              }
            ]
          }), r.abortEarly))
            break;
        }
        if (!n.issues || !r.abortEarly)
          for (const a in o)
            /* @__PURE__ */ fo(o, a) && !(a in this.entries) && (n.value[a] = o[a]);
      } else
        D(this, "type", n, r);
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function lt(e) {
  return {
    kind: "schema",
    type: "number",
    reference: lt,
    expects: "number",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ Q(this);
    },
    "~run"(t, n) {
      return typeof t.value == "number" && !isNaN(t.value) ? t.typed = !0 : D(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function w(e, t) {
  return {
    kind: "schema",
    type: "optional",
    reference: w,
    expects: `(${e.expects} | undefined)`,
    async: !1,
    wrapped: e,
    default: t,
    get "~standard"() {
      return /* @__PURE__ */ Q(this);
    },
    "~run"(n, r) {
      return n.value === void 0 && (this.default !== void 0 && (n.value = /* @__PURE__ */ _o(this, n, r)), n.value === void 0) ? (n.typed = !0, n) : this.wrapped["~run"](n, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function go(e, t, n) {
  return {
    kind: "schema",
    type: "record",
    reference: go,
    expects: "Object",
    async: !1,
    key: e,
    value: t,
    message: n,
    get "~standard"() {
      return /* @__PURE__ */ Q(this);
    },
    "~run"(r, s) {
      var o, a;
      const i = r.value;
      if (i && typeof i == "object") {
        r.typed = !0, r.value = {};
        for (const u in i)
          if (/* @__PURE__ */ fo(i, u)) {
            const c = i[u], l = this.key["~run"]({ value: u }, s);
            if (l.issues) {
              const m = {
                type: "object",
                origin: "key",
                input: i,
                key: u,
                value: c
              };
              for (const f of l.issues)
                f.path = [m], (o = r.issues) == null || o.push(f);
              if (r.issues || (r.issues = l.issues), s.abortEarly) {
                r.typed = !1;
                break;
              }
            }
            const p = this.value["~run"](
              { value: c },
              s
            );
            if (p.issues) {
              const m = {
                type: "object",
                origin: "value",
                input: i,
                key: u,
                value: c
              };
              for (const f of p.issues)
                f.path ? f.path.unshift(m) : f.path = [m], (a = r.issues) == null || a.push(f);
              if (r.issues || (r.issues = p.issues), s.abortEarly) {
                r.typed = !1;
                break;
              }
            }
            (!l.typed || !p.typed) && (r.typed = !1), l.typed && (r.value[l.value] = p.value);
          }
      } else
        D(this, "type", r, s);
      return r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function g(e) {
  return {
    kind: "schema",
    type: "string",
    reference: g,
    expects: "string",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ Q(this);
    },
    "~run"(t, n) {
      return typeof t.value == "string" ? t.typed = !0 : D(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function jr(e) {
  let t;
  if (e)
    for (const n of e)
      t ? t.push(...n.issues) : t = n.issues;
  return t;
}
// @__NO_SIDE_EFFECTS__
function Dn(e, t) {
  return {
    kind: "schema",
    type: "union",
    reference: Dn,
    expects: /* @__PURE__ */ el(
      e.map((n) => n.expects),
      "|"
    ),
    async: !1,
    options: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ Q(this);
    },
    "~run"(n, r) {
      let s, o, a;
      for (const i of this.options) {
        const u = i["~run"]({ value: n.value }, r);
        if (u.typed)
          if (u.issues)
            o ? o.push(u) : o = [u];
          else {
            s = u;
            break;
          }
        else
          a ? a.push(u) : a = [u];
      }
      if (s)
        return s;
      if (o) {
        if (o.length === 1)
          return o[0];
        D(this, "type", n, r, {
          issues: /* @__PURE__ */ jr(o)
        }), n.typed = !0;
      } else {
        if ((a == null ? void 0 : a.length) === 1)
          return a[0];
        D(this, "type", n, r, {
          issues: /* @__PURE__ */ jr(a)
        });
      }
      return n;
    }
  };
}
function vo(e, t, n) {
  const r = e["~run"]({ value: t }, /* @__PURE__ */ po(n));
  if (r.issues)
    throw new tl(r.issues);
  return r.value;
}
// @__NO_SIDE_EFFECTS__
function ue(...e) {
  return {
    ...e[0],
    pipe: e,
    get "~standard"() {
      return /* @__PURE__ */ Q(this);
    },
    "~run"(t, n) {
      for (const r of e)
        if (r.kind !== "metadata") {
          if (t.issues && (r.kind === "schema" || r.kind === "transformation")) {
            t.typed = !1;
            break;
          }
          (!t.issues || !n.abortEarly && !n.abortPipeEarly) && (t = r["~run"](t, n));
        }
      return t;
    }
  };
}
function nl(e) {
  return e.replace(/_[a-z]/g, (t) => t[1].toUpperCase());
}
function rl(e) {
  return Object.entries(e).reduce((t, [n, r]) => (t[nl(n)] = r, t), {});
}
function Xt(e) {
  const t = rl(e);
  for (const n in t) {
    const r = t[n];
    r && typeof r == "object" && !(r instanceof Date) && (t[n] = Array.isArray(r) ? r.map(Xt) : Xt(r));
  }
  return t;
}
function Nn(e) {
  return /* @__PURE__ */ ie((t) => e ? Xt(t) : t);
}
function wo(e) {
  return (t) => /* @__PURE__ */ ue(
    e,
    Nn(t)
  );
}
function Eo(e) {
  return (t, n) => vo(
    /* @__PURE__ */ ue(e, Nn(n)),
    t
  );
}
function $o() {
  return /* @__PURE__ */ ie(JSON.parse);
}
function Vn(e) {
  const t = wo(e);
  return (n) => /* @__PURE__ */ ue(
    /* @__PURE__ */ g(),
    $o(),
    t(n)
  );
}
function So(e) {
  return /* @__PURE__ */ ie((t) => {
    const n = {};
    return new URLSearchParams(t).forEach((r, s) => {
      const o = n[s];
      Array.isArray(o) ? o.push(r) : o === void 0 ? n[s] = r : n[s] = [o, r];
    }), vo(e, n);
  });
}
function Co(e) {
  return (t) => /* @__PURE__ */ ue(
    /* @__PURE__ */ Dn([/* @__PURE__ */ g(), /* @__PURE__ */ yo(URLSearchParams)]),
    So(e),
    Nn(t)
  );
}
const qr = /* @__PURE__ */ w(/* @__PURE__ */ qn(() => ul())), sl = /* @__PURE__ */ Fe({
  id: /* @__PURE__ */ lt(),
  photo_url: /* @__PURE__ */ w(/* @__PURE__ */ g()),
  type: /* @__PURE__ */ g(),
  title: /* @__PURE__ */ g(),
  username: /* @__PURE__ */ w(/* @__PURE__ */ g())
}), ol = /* @__PURE__ */ Fe({
  added_to_attachment_menu: /* @__PURE__ */ w(/* @__PURE__ */ Be()),
  allows_write_to_pm: /* @__PURE__ */ w(/* @__PURE__ */ Be()),
  first_name: /* @__PURE__ */ g(),
  id: /* @__PURE__ */ lt(),
  is_bot: /* @__PURE__ */ w(/* @__PURE__ */ Be()),
  is_premium: /* @__PURE__ */ w(/* @__PURE__ */ Be()),
  last_name: /* @__PURE__ */ w(/* @__PURE__ */ g()),
  language_code: /* @__PURE__ */ w(/* @__PURE__ */ g()),
  photo_url: /* @__PURE__ */ w(/* @__PURE__ */ g()),
  username: /* @__PURE__ */ w(/* @__PURE__ */ g())
}), al = /* @__PURE__ */ Fe({
  auth_date: /* @__PURE__ */ ue(
    /* @__PURE__ */ g(),
    /* @__PURE__ */ ie((e) => new Date(Number(e) * 1e3)),
    /* @__PURE__ */ bo()
  ),
  can_send_after: /* @__PURE__ */ w(/* @__PURE__ */ ue(/* @__PURE__ */ g(), /* @__PURE__ */ ie(Number), /* @__PURE__ */ ho())),
  chat: /* @__PURE__ */ w(/* @__PURE__ */ qn(() => il())),
  chat_type: /* @__PURE__ */ w(/* @__PURE__ */ g()),
  chat_instance: /* @__PURE__ */ w(/* @__PURE__ */ g()),
  hash: /* @__PURE__ */ g(),
  query_id: /* @__PURE__ */ w(/* @__PURE__ */ g()),
  receiver: qr,
  start_param: /* @__PURE__ */ w(/* @__PURE__ */ g()),
  signature: /* @__PURE__ */ g(),
  user: qr
}), il = Vn(sl), ul = Vn(ol), ko = Co(al);
function we(e) {
  return /^#[\da-f]{6}$/i.test(e);
}
function cl(e) {
  return /^#[\da-f]{3}$/i.test(e);
}
function ll(e) {
  const t = e.replace(/\s/g, "").toLowerCase();
  if (we(t))
    return t;
  if (cl(t)) {
    let r = "#";
    for (let s = 0; s < 3; s += 1)
      r += t[1 + s].repeat(2);
    return r;
  }
  const n = t.match(/^rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)$/) || t.match(/^rgba\((\d{1,3}),(\d{1,3}),(\d{1,3}),\d{1,3}\)$/);
  if (!n)
    throw new Error(`Value "${e}" does not satisfy any of known RGB formats.`);
  return n.slice(1).reduce((r, s) => r + parseInt(s, 10).toString(16).padStart(2, "0"), "#");
}
const pl = wo(
  /* @__PURE__ */ go(
    /* @__PURE__ */ g(),
    /* @__PURE__ */ ue(
      /* @__PURE__ */ Dn([/* @__PURE__ */ g(), /* @__PURE__ */ lt()]),
      /* @__PURE__ */ ie((e) => typeof e == "number" ? `#${(e & 16777215).toString(16).padStart(6, "0")}` : e),
      /* @__PURE__ */ mo(we)
    )
  )
), xt = /* @__PURE__ */ w(
  /* @__PURE__ */ ue(/* @__PURE__ */ g(), /* @__PURE__ */ ie((e) => e === "1"))
), Dr = Vn(pl()), dl = /* @__PURE__ */ Fe({
  tgWebAppBotInline: xt,
  tgWebAppData: /* @__PURE__ */ w(ko()),
  tgWebAppDefaultColors: /* @__PURE__ */ w(Dr()),
  tgWebAppFullscreen: xt,
  tgWebAppPlatform: /* @__PURE__ */ g(),
  tgWebAppShowSettings: xt,
  tgWebAppStartParam: /* @__PURE__ */ w(/* @__PURE__ */ g()),
  tgWebAppThemeParams: Dr(),
  tgWebAppVersion: /* @__PURE__ */ g()
}), fl = Co(dl), Jf = Eo(ko()), Kf = Eo(fl());
function Ao(e, t) {
  return t || (t = (n, r) => JSON.stringify(r)), new URLSearchParams(
    Object.entries(e).reduce((n, [r, s]) => (Array.isArray(s) ? n.push(...s.map((o) => [r, String(o)])) : s != null && n.push([
      r,
      s instanceof Date ? (s.getTime() / 1e3 | 0).toString() : typeof s == "string" || typeof s == "number" ? String(s) : typeof s == "boolean" ? s ? "1" : "0" : t(r, s)
    ]), n), [])
  ).toString();
}
function ml(e) {
  return Ao(e);
}
function Yf(e) {
  return Ao(e, (t, n) => t === "tgWebAppData" ? ml(n) : JSON.stringify(n));
}
function Mo(e) {
  const t = ll(e);
  return Math.sqrt(
    [0.299, 0.587, 0.114].reduce((n, r, s) => {
      const o = parseInt(t.slice(1 + s * 2, 1 + (s + 1) * 2), 16);
      return n + o * o * r;
    }, 0)
  ) < 120;
}
const [Tt, hl] = /* @__PURE__ */ b(!1), [ge, _l] = /* @__PURE__ */ b({});
function T(e) {
  return /* @__PURE__ */ h(() => ge()[e]);
}
const bl = T("accent_text_color"), pt = T("bg_color"), Ln = T("button_color"), Po = T("button_text_color"), xo = T("bottom_bar_bg_color"), yl = T("destructive_text_color"), gl = T("header_bg_color"), vl = T("hint_color"), wl = /* @__PURE__ */ h(() => {
  const e = pt();
  return !e || Mo(e);
}), El = T("link_color"), Je = T("secondary_bg_color"), $l = T("section_bg_color"), Sl = T("section_header_text_color"), Cl = T("section_separator_color"), kl = T("subtitle_text_color"), Al = T("text_color");
function me(e) {
  return /* @__PURE__ */ h(() => Rn()[e]);
}
const je = /* @__PURE__ */ Ce({
  hasShineEffect: !1,
  isEnabled: !0,
  isLoaderVisible: !1,
  isVisible: !1,
  text: "Continue"
}), Rn = /* @__PURE__ */ h(() => {
  const e = je();
  return {
    ...e,
    backgroundColor: e.backgroundColor || Ln() || "#2481cc",
    textColor: e.textColor || Po() || "#ffffff"
  };
}), [en, To] = /* @__PURE__ */ b(!1), Ml = me("backgroundColor"), Pl = me("hasShineEffect"), xl = me("isEnabled"), Tl = me("isLoaderVisible"), Bl = me("isVisible"), Ol = me("text"), Il = me("textColor"), jl = "web_app_setup_main_button", Bo = "main_button_pressed", dt = "mainButton", Hn = le(dt), ql = it(dt, To), Dl = Hn("mount", () => {
  if (!en()) {
    const e = z() && U(dt);
    e && je.set(e), en.set(!0);
  }
}), Nl = Hn(
  "onClick",
  (e) => k(Bo, e)
), Vl = Hn(
  "offClick",
  (e) => {
    B(Bo, e);
  }
), Ll = ql(
  "setParams",
  (e) => {
    je.set({ ...je(), ...jn(e) }), W(dt, je());
    const t = Rn();
    t.text && _(jl, {
      color: t.backgroundColor,
      has_shine_effect: t.hasShineEffect,
      is_active: t.isEnabled,
      is_progress_visible: t.isLoaderVisible,
      is_visible: t.isVisible,
      text: t.text,
      text_color: t.textColor
    });
  }
);
function Rl() {
  en.set(!1);
}
const Zf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  backgroundColor: Ml,
  hasShineEffect: Pl,
  isEnabled: xl,
  isLoaderVisible: Tl,
  isMounted: To,
  isVisible: Bl,
  mount: Dl,
  offClick: Vl,
  onClick: Nl,
  setParams: Ll,
  state: Rn,
  text: Ol,
  textColor: Il,
  unmount: Rl
}, Symbol.toStringTag, { value: "Module" }));
function Fn(e, t) {
  document.documentElement.style.setProperty(e, t);
}
function Wn(e) {
  document.documentElement.style.removeProperty(e);
}
const Ne = "themeParams", Oo = "theme_changed", Hl = le(Ne), Io = ({ theme_params: e }) => {
  ge.set(e), W(Ne, e);
}, [
  Fl,
  Wl,
  Ul,
  jo
] = /* @__PURE__ */ Le(
  Ne,
  (e) => {
    const t = z() && U(Ne);
    return t ? x.resolve(t) : S("web_app_request_theme", "theme_changed", e).then((n) => n.theme_params);
  },
  (e) => {
    k(Oo, Io), ge.set(e);
  }
), zl = it(Ne, jo[0]), Gl = zl(
  "bindCssVars",
  (e) => {
    if (Tt())
      throw new vn();
    e || (e = (r) => `--tg-theme-${Ni(r)}`);
    function t(r) {
      Object.entries(ge()).forEach(([s, o]) => {
        o && r(s, o);
      });
    }
    function n() {
      t((r, s) => {
        Fn(e(r), s);
      });
    }
    return n(), ge.sub(n), Tt.set(!0), () => {
      t(Wn), ge.unsub(n), Tt.set(!1);
    };
  }
), qo = Hl("mount", Fl), [, Do, Ql] = Wl, [, Jl] = Ul, [Kl, Yl] = jo;
function Zl() {
  Ae(Do), B(Oo, Io), Kl.set(!1);
}
// @__NO_SIDE_EFFECTS__
function No(e) {
  return /* @__PURE__ */ h(() => {
    const t = e();
    return we(t) ? t : t === "bg_color" ? pt() : Je();
  });
}
const [Ke, Xl] = /* @__PURE__ */ b("bg_color"), Un = /* @__PURE__ */ No(Ke), [Ye, ep] = /* @__PURE__ */ b("bottom_bar_bg_color"), zn = /* @__PURE__ */ h(() => {
  const e = Ye();
  return we(e) ? e : e === "bottom_bar_bg_color" ? xo() || Je() : e === "secondary_bg_color" ? Je() : pt();
}), [Ze, tp] = /* @__PURE__ */ b("bg_color"), Vo = /* @__PURE__ */ No(Ze), [Bt, np] = /* @__PURE__ */ b(!1), rp = /* @__PURE__ */ h(() => {
  const e = Un();
  return e ? Mo(e) : !1;
}), [Gn, sp] = /* @__PURE__ */ b(!0), Lo = /* @__PURE__ */ h(() => ({
  backgroundColor: Ke(),
  bottomBarColor: Ye(),
  headerColor: Ze(),
  isActive: Gn()
})), tn = "web_app_set_background_color", nn = "web_app_set_bottom_bar_color", ze = "web_app_set_header_color", Ro = "visibility_changed", Ee = "miniApp", Qn = {
  any: [
    tn,
    nn,
    ze
  ]
}, op = /* @__PURE__ */ h(() => Qn.any.some((e) => de(e, se()))), Ho = (e) => {
  Gn.set(e.is_visible), mt();
}, [
  ap,
  ip,
  up,
  Fo
] = /* @__PURE__ */ Le(
  Ee,
  (e) => qo(e).then(() => z() && U(Ee) || void 0),
  (e) => {
    zo.ifAvailable(e ? e.backgroundColor : "bg_color"), Go.ifAvailable(e ? e.bottomBarColor : "bottom_bar_bg_color"), Qo.ifAvailable(e ? e.headerColor : "bg_color"), Gn.set(e ? e.isActive : !0), k(Ro, Ho);
  }
), Wo = le(Ee), cp = N(Ee, Qn), ft = ce(Ee, Fo[0], Qn), lp = ft(
  "bindCssVars",
  (e) => {
    if (Bt())
      throw new vn();
    const [t, n] = yn();
    function r(s, o) {
      function a() {
        Fn(s, o() || null);
      }
      a(), t(o.sub(a), Wn.bind(null, s));
    }
    return e || (e = (s) => `--tg-${Cs(s)}`), r(e("bgColor"), Un), r(e("bottomBarColor"), zn), r(e("headerColor"), Vo), t(() => {
      Bt.set(!1);
    }), Bt.set(!0), n;
  }
), pp = Wo("close", (e) => {
  _("web_app_close", { return_back: e });
}), dp = cp("mount", ap), [, Uo, fp] = ip, [, mp] = up, [hp, _p] = Fo, bp = Wo("ready", () => {
  _("web_app_ready");
});
function mt() {
  W(Ee, Lo());
}
const zo = ft(
  "setBackgroundColor",
  (e) => {
    e !== Ke() && (_(tn, { color: e }), Ke.set(e), mt());
  },
  tn
), Go = ft(
  "setBottomBarColor",
  (e) => {
    e !== Ye() && (_(nn, { color: e }), Ye.set(e), mt());
  },
  nn
), Qo = ft(
  "setHeaderColor",
  (e) => {
    e !== Ze() && (_(ze, we(e) ? { color: e } : { color_key: e }), Ze.set(e), mt());
  },
  ze,
  {
    rgb: [ze, "color", we]
  }
);
function yp() {
  Ae(Uo), B(Ro, Ho), hp.set(!1);
}
const Xf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  backgroundColor: Xl,
  backgroundColorRGB: Un,
  bindCssVars: lp,
  bottomBarColor: ep,
  bottomBarColorRGB: zn,
  close: pp,
  headerColor: tp,
  headerColorRGB: Vo,
  isActive: sp,
  isCssVarsBound: np,
  isDark: rp,
  isMounted: _p,
  isMounting: fp,
  isSupported: op,
  mount: dp,
  mountError: mp,
  mountPromise: Uo,
  ready: bp,
  setBackgroundColor: zo,
  setBottomBarColor: Go,
  setHeaderColor: Qo,
  state: Lo,
  unmount: yp
}, Symbol.toStringTag, { value: "Module" }));
function gp(e) {
  const t = e.message.trim(), n = (e.title || "").trim(), r = e.buttons || [];
  if (n.length > 64)
    throw new J(`Invalid title: ${n}`);
  if (!t || t.length > 256)
    throw new J(`Invalid message: ${t}`);
  if (r.length > 3)
    throw new J(`Invalid buttons count: ${r.length}`);
  return {
    title: n,
    message: t,
    buttons: r.length ? r.map((s, o) => {
      const a = s.id || "";
      if (a.length > 64)
        throw new J(`Button with index ${o} has invalid id: ${a}`);
      if (!s.type || s.type === "default" || s.type === "destructive") {
        const i = s.text.trim();
        if (!i || i.length > 64)
          throw new J(`Button with index ${o} has invalid text: ${i}`);
        return { type: s.type, text: i, id: a };
      }
      return { type: s.type, id: a };
    }) : [{ type: "close", id: "" }]
  };
}
const Jn = "web_app_open_popup", Jo = N("popup", Jn), vp = G(Jn), [Ko, Kn, Yo] = O(
  (e) => S(Jn, "popup_closed", {
    ...e,
    params: gp(e)
  }).then(({ button_id: t }) => t === void 0 ? null : t),
  "A popup is already opened"
), wp = Jo("open", Ko), Ep = Kn[1], $p = Kn[2], Sp = Yo[1], Cp = Jo("show", Ko), [, kp, Ap] = Kn, [, Mp] = Yo, em = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isOpened: $p,
  isShown: Ap,
  isSupported: vp,
  open: wp,
  openError: Sp,
  openPromise: Ep,
  show: Cp,
  showError: Mp,
  showPromise: kp
}, Symbol.toStringTag, { value: "Module" })), Zo = "web_app_close_scan_qr_popup", Yn = "web_app_open_scan_qr_popup", Pp = "scan_qr_popup_closed", xp = "qr_text_received", Xo = N("qrScanner", Yn), Tp = Xo("close", () => {
  _(Zo), Ae(ea);
}), Bp = G(Yn);
function Op(e) {
  e || (e = {});
  const { onCaptured: t, text: n, capture: r } = e, [, s] = yn(
    k(Pp, () => {
      o.resolve();
    }),
    k(xp, (a) => {
      t ? t(a.data) : (!r || r(a.data)) && (o.resolve(a.data), _(Zo));
    })
  ), o = new du(e);
  return (e.postEvent || _)(Yn, { text: n }), x.resolve(o).catch(Ds).finally(s);
}
const [
  Ip,
  jp,
  qp
] = O(Op, "The QR Scanner is already opened"), Dp = Xo("open", Ip), [, ea, Np] = jp, [, Vp] = qp, tm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  close: Tp,
  isOpened: Np,
  isSupported: Bp,
  open: Dp,
  openError: Vp,
  openPromise: ea
}, Symbol.toStringTag, { value: "Module" }));
function pe(e) {
  return /* @__PURE__ */ h(() => Zn()[e]);
}
const qe = /* @__PURE__ */ Ce({
  hasShineEffect: !1,
  isEnabled: !0,
  isLoaderVisible: !1,
  isVisible: !1,
  position: "left",
  text: "Cancel"
}), Zn = /* @__PURE__ */ h(() => {
  const e = qe();
  return {
    ...e,
    backgroundColor: e.backgroundColor || zn() || "#000000",
    textColor: e.textColor || Ln() || "#2481cc"
  };
}), [rn, ta] = /* @__PURE__ */ b(!1), Lp = pe("backgroundColor"), Rp = pe("hasShineEffect"), Hp = pe("isEnabled"), Fp = pe("isLoaderVisible"), Wp = pe("isVisible"), Up = pe("position"), zp = pe("text"), Gp = pe("textColor"), ht = "web_app_setup_secondary_button", na = "secondary_button_pressed", _t = "secondaryButton", Xn = N(_t, ht), Qp = ce(_t, ta, ht), Jp = G(ht), Kp = Xn("mount", () => {
  if (!rn()) {
    const e = z() && U(_t);
    e && qe.set(e), rn.set(!0);
  }
}), Yp = Xn(
  "onClick",
  (e) => k(na, e)
), Zp = Xn(
  "offClick",
  (e) => {
    B(na, e);
  }
), Xp = Qp(
  "setParams",
  (e) => {
    qe.set({ ...qe(), ...jn(e) }), W(_t, qe());
    const t = Zn();
    t.text && _(ht, {
      color: t.backgroundColor,
      has_shine_effect: t.hasShineEffect,
      is_active: t.isEnabled,
      is_progress_visible: t.isLoaderVisible,
      is_visible: t.isVisible,
      position: t.position,
      text: t.text,
      text_color: t.textColor
    });
  }
);
function ed() {
  rn.set(!1);
}
const nm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  backgroundColor: Lp,
  hasShineEffect: Rp,
  isEnabled: Hp,
  isLoaderVisible: Fp,
  isMounted: ta,
  isSupported: Jp,
  isVisible: Wp,
  mount: Kp,
  offClick: Zp,
  onClick: Yp,
  position: Up,
  setParams: Xp,
  state: Zn,
  text: zp,
  textColor: Gp,
  unmount: ed
}, Symbol.toStringTag, { value: "Module" })), bt = "web_app_setup_settings_button", ra = "settings_button_pressed", yt = "settingsButton", [Nr, td] = /* @__PURE__ */ b(!1), [Xe, nd] = /* @__PURE__ */ b(!1), rd = G(bt), er = N(yt, bt), sa = ce(yt, Xe, bt), sd = sa("hide", () => {
  tr(!1);
}), od = er("mount", () => {
  Xe() || (tr(z() && U(yt) || !1), Xe.set(!0));
});
function tr(e) {
  e !== Nr() && (_(bt, { is_visible: e }), W(yt, e), Nr.set(e));
}
const ad = er(
  "onClick",
  (e) => k(ra, e)
), id = er(
  "offClick",
  (e) => {
    B(ra, e);
  }
), ud = sa("show", () => {
  tr(!0);
});
function cd() {
  Xe.set(!1);
}
const rm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hide: sd,
  isMounted: nd,
  isSupported: rd,
  isVisible: td,
  mount: od,
  offClick: id,
  onClick: ad,
  show: ud,
  unmount: cd
}, Symbol.toStringTag, { value: "Module" })), gt = "web_app_setup_swipe_behavior", vt = "swipeBehavior", [Ve, ld] = /* @__PURE__ */ b(!1), pd = G(gt), [sn, dd] = /* @__PURE__ */ b(!0), fd = N(vt, gt), oa = ce(vt, Ve, gt), md = oa("disableVertical", () => {
  nr(!1);
}), hd = oa("enableVertical", () => {
  nr(!0);
}), _d = fd("mount", () => {
  Ve() || (nr(
    z() && U(vt) || !1,
    !0
  ), Ve.set(!0));
});
function nr(e, t) {
  (e !== sn() || t) && (_(gt, { allow_vertical_swipe: e }), W(vt, e), sn.set(e));
}
function bd() {
  Ve.set(!1);
}
const sm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _isMounted: Ve,
  _isVerticalEnabled: sn,
  disableVertical: md,
  enableVertical: hd,
  isMounted: ld,
  isSupported: pd,
  isVerticalEnabled: dd,
  mount: _d,
  unmount: bd
}, Symbol.toStringTag, { value: "Module" })), om = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accentTextColor: bl,
  backgroundColor: pt,
  bindCssVars: Gl,
  bottomBarBgColor: xo,
  buttonColor: Ln,
  buttonTextColor: Po,
  destructiveTextColor: yl,
  headerBackgroundColor: gl,
  hintColor: vl,
  isCssVarsBound: hl,
  isDark: wl,
  isMounted: Yl,
  isMounting: Ql,
  linkColor: El,
  mount: qo,
  mountError: Jl,
  mountPromise: Do,
  secondaryBackgroundColor: Je,
  sectionBackgroundColor: $l,
  sectionHeaderTextColor: Sl,
  sectionSeparatorColor: Cl,
  state: _l,
  subtitleTextColor: kl,
  textColor: Al,
  unmount: Zl
}, Symbol.toStringTag, { value: "Module" })), he = "viewport", rr = "fullscreen_changed", sr = "safe_area_changed", or = "content_safe_area_changed", ar = "viewport_changed", aa = le(he), Vr = { left: 0, top: 0, bottom: 0, right: 0 };
function Ot(e) {
  return Math.max(e, 0);
}
const [It, ia] = /* @__PURE__ */ b({
  contentSafeAreaInsets: Vr,
  height: 0,
  isExpanded: !1,
  isFullscreen: !1,
  safeAreaInsets: Vr,
  stableHeight: 0,
  width: 0
});
function _e(e) {
  return /* @__PURE__ */ h(() => ia()[e]);
}
const ir = _e("height"), ur = _e("stableHeight"), ua = _e("width"), yd = _e("isExpanded"), gd = /* @__PURE__ */ h(() => ir() === ur());
function Me(e) {
  const { height: t, stableHeight: n, width: r } = e;
  It.set({
    ...It(),
    ...jn({
      ...e,
      height: t ? Ot(t) : void 0,
      width: r ? Ot(r) : void 0,
      stableHeight: n ? Ot(n) : void 0
    })
  }), W(he, It());
}
function vd() {
  return U(he);
}
function wt(e) {
  return /* @__PURE__ */ h(() => cr()[e]);
}
const cr = _e("contentSafeAreaInsets"), ca = wt("bottom"), la = wt("left"), pa = wt("right"), da = wt("top");
function Et(e) {
  return /* @__PURE__ */ h(() => lr()[e]);
}
const lr = _e("safeAreaInsets"), fa = Et("bottom"), ma = Et("left"), ha = Et("right"), _a = Et("top"), ba = "web_app_request_safe_area", ya = N(he, ba), Lr = ya(
  "requestContentSafeAreaInsets",
  (e) => S("web_app_request_content_safe_area", or, e)
);
function wd(e) {
  return S("web_app_request_viewport", ar, e);
}
const Rr = ya(
  "requestSafeAreaInsets",
  (e) => S(ba, sr, e)
), ga = (e) => {
  const { height: t } = e;
  Me({
    isExpanded: e.is_expanded,
    height: t,
    width: e.width,
    stableHeight: e.is_state_stable ? t : void 0
  });
}, va = (e) => {
  Me({ isFullscreen: e.is_fullscreen });
}, wa = (e) => {
  Me({ safeAreaInsets: e });
}, Ea = (e) => {
  Me({ contentSafeAreaInsets: e });
}, [
  Ed,
  $d,
  Sd,
  Cd
] = /* @__PURE__ */ Le(
  he,
  (e) => {
    const t = z() && vd();
    return t ? x.resolve(t) : x.fn(async (n) => {
      const r = await x.all([
        Rr.isAvailable() ? Rr(n) : lr(),
        Lr.isAvailable() ? Lr(n) : cr()
      ]), s = gn(), o = {
        contentSafeAreaInsets: r[1],
        isFullscreen: !!s.tgWebAppFullscreen,
        safeAreaInsets: r[0]
      };
      if (["macos", "tdesktop", "unigram", "webk", "weba", "web"].includes(s.tgWebAppPlatform)) {
        const a = window;
        return {
          ...o,
          height: a.innerHeight,
          isExpanded: !0,
          stableHeight: a.innerHeight,
          width: a.innerWidth
        };
      }
      return wd(n).then((a) => ({
        ...o,
        height: a.height,
        isExpanded: a.is_expanded,
        stableHeight: a.is_state_stable ? a.height : 0,
        width: a.width
      }));
    }, e);
  },
  (e) => {
    k(ar, ga), k(rr, va), k(sr, wa), k(or, Ea), Me(e);
  }
), kd = aa("mount", Ed), [, $a, Ad] = $d, [, Md] = Sd, [pr, Pd] = Cd;
function xd() {
  Ae($a), B(ar, ga), B(rr, va), B(sr, wa), B(or, Ea), pr.set(!1);
}
const Td = it(he, pr), [jt, Bd] = /* @__PURE__ */ b(!1), Od = Td(
  "bindCssVars",
  (e) => {
    if (jt())
      throw new vn();
    e || (e = (n) => `--tg-viewport-${Cs(n)}`);
    const t = [
      ["height", ir],
      ["stableHeight", ur],
      ["width", ua],
      ["safeAreaInsetTop", _a],
      ["safeAreaInsetBottom", fa],
      ["safeAreaInsetLeft", ma],
      ["safeAreaInsetRight", ha],
      ["contentSafeAreaInsetTop", da],
      ["contentSafeAreaInsetBottom", ca],
      ["contentSafeAreaInsetLeft", la],
      ["contentSafeAreaInsetRight", pa]
    ].reduce((n, [r, s]) => {
      const o = e(r);
      if (o) {
        const a = () => {
          Fn(o, `${s()}px`);
        };
        n.push([a, s.sub(a), o]);
      }
      return n;
    }, []);
    return t.forEach((n) => {
      n[0]();
    }), jt.set(!0), () => {
      t.forEach((n) => {
        n[1](), Wn(n[2]);
      }), jt.set(!1);
    };
  }
), Id = aa("expand", () => {
  _("web_app_expand");
}), Sa = "web_app_request_fullscreen", jd = ce(he, pr, Sa), Ca = _e("isFullscreen"), [
  qd,
  Dd
] = /* @__PURE__ */ b(), [
  Nd,
  Vd
] = /* @__PURE__ */ b();
function ka(e, t) {
  return jd(
    e,
    O(
      (n) => S(
        t ? Sa : "web_app_exit_fullscreen",
        [rr, "fullscreen_failed"],
        n
      ).then((r) => {
        if ("error" in r && r.error !== "ALREADY_FULLSCREEN")
          throw new Qi(r.error);
        const s = "is_fullscreen" in r ? r.is_fullscreen : !0;
        s !== Ca() && Me({ isFullscreen: s });
      }),
      "Fullscreen mode change is already being requested",
      {
        promise: qd,
        error: Nd
      }
    )[0]
  );
}
const Ld = ka("requestFullscreen", !0), Rd = ka("exitFullscreen"), am = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bindCssVars: Od,
  changeFullscreenError: Vd,
  changeFullscreenPromise: Dd,
  contentSafeAreaInsetBottom: ca,
  contentSafeAreaInsetLeft: la,
  contentSafeAreaInsetRight: pa,
  contentSafeAreaInsetTop: da,
  contentSafeAreaInsets: cr,
  exitFullscreen: Rd,
  expand: Id,
  height: ir,
  isCssVarsBound: Bd,
  isExpanded: yd,
  isFullscreen: Ca,
  isMounted: Pd,
  isMounting: Ad,
  isStable: gd,
  mount: kd,
  mountError: Md,
  mountPromise: $a,
  requestFullscreen: Ld,
  safeAreaInsetBottom: fa,
  safeAreaInsetLeft: ma,
  safeAreaInsetRight: ha,
  safeAreaInsetTop: _a,
  safeAreaInsets: lr,
  stableHeight: ur,
  state: ia,
  unmount: xd,
  width: ua
}, Symbol.toStringTag, { value: "Module" })), Aa = "web_app_request_emoji_status_access", [
  Hd,
  Fd,
  Wd
] = O((e) => S(Aa, "emoji_status_access_requested", e).then((t) => t.status), "Emoji status access request is already in progress"), im = /* @__PURE__ */ C(
  "requestEmojiStatusAccess",
  Hd,
  { isSupported: Aa }
), [, um, cm] = Fd, [, lm] = Wd, Ma = "web_app_set_emoji_status", [
  Ud,
  zd,
  Gd
] = O(
  (e, t) => S(Ma, ["emoji_status_set", "emoji_status_failed"], {
    params: {
      custom_emoji_id: e,
      duration: (t || {}).duration
    },
    ...t
  }).then((n) => {
    if (n && "error" in n)
      throw new Gi(n.error);
  }),
  "Emoji status set request is currently in progress"
), pm = /* @__PURE__ */ C("setEmojiStatus", Ud, {
  isSupported: Ma
}), [, dm, fm] = zd, [, mm] = Gd, Qd = { isSupported: "web_app_add_to_home_screen" }, Pa = "home_screen_failed", hm = /* @__PURE__ */ C(
  "onAddToHomeScreenFailed",
  (e, t) => k(Pa, e, t),
  { isSupported: "web_app_add_to_home_screen" }
), _m = /* @__PURE__ */ C(
  "offAddToHomeScreenFailed",
  (e) => {
    B(Pa, e);
  },
  Qd
), xa = { isSupported: "web_app_add_to_home_screen" }, Ta = "home_screen_added", bm = /* @__PURE__ */ C(
  "onAddedToHomeScreen",
  (e, t) => k(Ta, e, t),
  xa
), ym = /* @__PURE__ */ C(
  "offAddedToHomeScreen",
  (e) => {
    B(Ta, e);
  },
  xa
), Hr = "web_app_add_to_home_screen", gm = /* @__PURE__ */ C(
  "addToHomeScreen",
  () => {
    _(Hr);
  },
  { isSupported: Hr }
), Ba = "web_app_check_home_screen", [
  Jd,
  Kd,
  Yd
] = O((e) => S(Ba, "home_screen_checked", e).then((t) => t.status || "unknown"), "Check home screen status request is currently in progress"), vm = /* @__PURE__ */ C("checkHomeScreenStatus", Jd, {
  isSupported: Ba
}), [, wm, Em] = Kd, [, $m] = Yd, Zd = le(), Sm = Zd(
  "openLink",
  (e, t) => {
    if (typeof e == "string")
      try {
        e = new URL(e);
      } catch (n) {
        throw new J(`"${e.toString()}" is invalid URL`, n);
      }
    t || (t = {}), _("web_app_open_link", {
      url: e.toString(),
      try_browser: t.tryBrowser,
      try_instant_view: t.tryInstantView
    });
  }
), Fr = "web_app_open_tg_link", Xd = le(), ef = Xd(
  "openTelegramLink",
  (e) => {
    const t = e.toString();
    if (!t.match(/^https:\/\/t.me\/.+/))
      throw new J(`"${t}" is invalid URL`);
    if (!de(Fr, se())) {
      window.location.href = t;
      return;
    }
    e = new URL(e), _(Fr, { path_full: e.pathname + e.search });
  }
), tf = le(), Cm = tf(
  "shareURL",
  (e, t) => {
    ef(
      "https://t.me/share/url?" + new URLSearchParams({ url: e, text: t || "" }).toString().replace(/\+/g, "%20")
    );
  }
);
function nf(e, t) {
  return new x({ abortSignal: t, timeout: e }).catch(() => {
  });
}
const Oa = "web_app_request_phone", [
  rf,
  sf,
  of
] = O((e) => S(Oa, "phone_requested", e).then((t) => t.status), "Phone access request is currently in progress"), af = /* @__PURE__ */ C("requestPhoneAccess", rf, {
  isSupported: Oa
}), [, km, Am] = sf, [, Mm] = of;
async function Wr(e) {
  const t = await ke("getRequestedContact", {}, {
    ...e,
    timeout: (e || {}).timeout || 5e3
  });
  return ct(
    /* @__PURE__ */ Ue(
      // todo: Union is unnecessary here, but we use it to comply TypeScript checker.
      /* @__PURE__ */ to([/* @__PURE__ */ H(), /* @__PURE__ */ Zs(URLSearchParams)]),
      So(
        /* @__PURE__ */ Zt({
          contact: /* @__PURE__ */ Ue(
            /* @__PURE__ */ H(),
            $o(),
            /* @__PURE__ */ Zt({
              user_id: /* @__PURE__ */ xn(),
              phone_number: /* @__PURE__ */ H(),
              first_name: /* @__PURE__ */ H(),
              last_name: /* @__PURE__ */ Xs(/* @__PURE__ */ H())
            })
          ),
          auth_date: /* @__PURE__ */ Ue(
            /* @__PURE__ */ H(),
            /* @__PURE__ */ Mn((n) => new Date(Number(n) * 1e3)),
            /* @__PURE__ */ Pn()
          ),
          hash: /* @__PURE__ */ H()
        })
      )
    ),
    t
  );
}
const [
  uf,
  cf,
  lf
] = O(
  (e) => new x(async (t, n, r) => {
    try {
      return t(await Wr(r));
    } catch (a) {
      if (a instanceof Yt)
        throw a;
    }
    if (await af(r) !== "sent")
      throw new Bs("User denied access");
    let o = 50;
    for (; !r.isAborted(); ) {
      try {
        return t(await Wr(r));
      } catch (a) {
        if (a instanceof Yt)
          throw a;
      }
      await nf(o), o += 50;
    }
  }, e),
  "Contact is already being requested"
), Pm = /* @__PURE__ */ C("requestContact", uf, {
  isSupported: "web_app_request_phone"
}), [, xm, Tm] = cf, [, Bm] = lf, Ia = "web_app_request_write_access", [
  pf,
  df,
  ff
] = O(
  (e) => S(Ia, "write_access_requested", e).then((t) => t.status),
  "Write access request is currently in progress"
), Om = /* @__PURE__ */ C("requestWriteAccess", pf, {
  isSupported: Ia
}), [, Im, jm] = df, [, qm] = ff;
function mf(e) {
  const t = document.createElement("textarea");
  t.value = e, t.style.top = "0", t.style.left = "0", t.style.position = "fixed", document.body.appendChild(t), t.focus(), t.select();
  try {
    document.execCommand("copy");
  } finally {
    document.body.removeChild(t);
  }
}
async function Dm(e) {
  try {
    const { clipboard: t } = navigator;
    if (t)
      return await t.writeText(e);
  } catch {
  }
  mf(e);
}
const Ur = "web_app_request_file_download", Nm = /* @__PURE__ */ C(
  "downloadFile",
  (e, t, n) => S(
    Ur,
    "file_download_requested",
    { ...n, params: { url: e, file_name: t } }
  ).then((r) => {
    if (r.status !== "downloading")
      throw new Bs("User denied the action");
  }),
  { isSupported: Ur }
), Vm = /* @__PURE__ */ C(
  "getCurrentTime",
  (e) => ke("getCurrentTime", {}, e).then((t) => ct(
    /* @__PURE__ */ Ue(/* @__PURE__ */ xn(), /* @__PURE__ */ Js(), /* @__PURE__ */ Mn((n) => new Date(n * 1e3)), /* @__PURE__ */ Pn()),
    t
  )),
  { isSupported: "web_app_invoke_custom_method" }
), zr = "web_app_read_text_from_clipboard", Lm = /* @__PURE__ */ C(
  "readTextFromClipboard",
  (e) => {
    const t = xs();
    return S(zr, "clipboard_text_received", {
      ...e,
      params: { req_id: t },
      capture: Ss(t)
    }).then(({ data: n = null }) => n);
  },
  { isSupported: zr }
), Gr = "web_app_data_send", Rm = /* @__PURE__ */ C(
  "sendData",
  (e) => {
    const { size: t } = new Blob([e]);
    if (!t || t > 4096)
      throw new J(t ? "Maximum size of data to send is 4096 bytes" : "Attempted to send empty data");
    _(Gr, { data: e });
  },
  { isSupported: Gr }
), Qr = "web_app_send_prepared_message", Hm = /* @__PURE__ */ C(
  "shareMessage",
  (e, t) => S(Qr, ["prepared_message_failed", "prepared_message_sent"], {
    ...t,
    params: { id: e }
  }).then((n) => {
    if (n && "error" in n)
      throw new Ji(n.error);
  }),
  { isSupported: Qr }
), Jr = "web_app_share_to_story", Fm = /* @__PURE__ */ C(
  "shareStory",
  (e, t) => {
    t || (t = {}), _(Jr, {
      text: t.text,
      media_url: e,
      widget_link: t.widgetLink
    });
  },
  { isSupported: Jr }
), hf = "web_app_switch_inline_query", Wm = /* @__PURE__ */ C(
  "switchInlineQuery",
  (e, t) => {
    _(hf, {
      query: e,
      chat_types: t || []
    });
  },
  {
    isSupported() {
      return gn().tgWebAppBotInline ? void 0 : "The application must be launched in the inline mode";
    }
  }
);
function Um(e) {
  try {
    return [!0, e()];
  } catch (t) {
    return [!1, t];
  }
}
function zm(e) {
  Wi(e);
  const [t, n] = yn(
    k("reload_iframe", () => {
      zt(!1, "Received a request to reload the page"), _("iframe_will_reload"), window.location.reload();
    })
  ), { acceptCustomStyles: r = !0 } = e || {};
  if (r) {
    const s = document.createElement("style");
    s.id = "telegram-custom-styles", document.head.appendChild(s), t(
      k("set_custom_style", (o) => {
        s.innerHTML = o;
      }),
      () => {
        document.head.removeChild(s);
      }
    );
  }
  return _("iframe_ready", { reload_supported: !0 }), zt(!1, "The package was initialized"), n;
}
export {
  un as AbortablePromise,
  Bs as AccessDeniedError,
  vn as CSSVarsBoundError,
  Ha as CancelledError,
  zi as ConcurrentCallError,
  Qi as FullscreenFailedError,
  Pe as FunctionUnavailableError,
  J as InvalidArgumentsError,
  Tf as InvalidEnvError,
  Ai as InvalidLaunchParamsError,
  Pi as InvokeCustomMethodError,
  ki as LaunchParamsRetrieveError,
  yf as ManualPromise,
  Si as MethodParameterUnsupportedError,
  $i as MethodUnsupportedError,
  Ts as NotAvailableError,
  Gi as SetEmojiStatusError,
  Ji as ShareMessageError,
  Fa as TimeoutError,
  Mi as UnknownEnvError,
  gm as addToHomeScreen,
  Mu as authenticateBiometry,
  Lf as backButton,
  lp as bindMiniAppCssVars,
  Gl as bindThemeParamsCssVars,
  Od as bindViewportCssVars,
  Hf as biometry,
  xu as biometryAuthError,
  Fs as biometryAuthPromise,
  Eu as biometryMountError,
  fu as biometryState,
  Vd as changeFullscreenError,
  Dd as changeFullscreenPromise,
  vm as checkHomeScreenStatus,
  $m as checkHomeScreenStatusError,
  wm as checkHomeScreenStatusPromise,
  pp as closeMiniApp,
  Tp as closeQrScanner,
  Ff as closingBehavior,
  Wf as cloudStorage,
  Wi as configure,
  Dm as copyTextToClipboard,
  qi as createPostEvent,
  xs as createRequestId,
  ro as deleteCloudStorageItem,
  Hu as disableClosingConfirmation,
  md as disableVerticalSwipes,
  Nm as downloadFile,
  yr as emitEvent,
  Fu as enableClosingConfirmation,
  hd as enableVerticalSwipes,
  Rd as exitFullscreen,
  Id as expandViewport,
  Xu as getCloudStorageItem,
  so as getCloudStorageKeys,
  Vm as getCurrentTime,
  Uf as hapticFeedback,
  rc as hapticFeedbackImpactOccurred,
  sc as hapticFeedbackNotificationOccurred,
  oc as hapticFeedbackSelectionChanged,
  Xi as hideBackButton,
  sd as hideSettingsButton,
  Ds as ignoreCanceled,
  zm as init,
  zf as initData,
  ao as initDataAuthDate,
  io as initDataCanSendAfter,
  ic as initDataCanSendAfterDate,
  uc as initDataChat,
  lc as initDataChatInstance,
  cc as initDataChatType,
  pc as initDataHash,
  dc as initDataQueryId,
  mc as initDataRaw,
  hc as initDataReceiver,
  bc as initDataStartParam,
  ac as initDataState,
  yc as initDataUser,
  Gf as invoice,
  ke as invokeCustomMethod,
  Df as isAccessDeniedError,
  Pu as isAuthenticatingBiometry,
  Yi as isBackButtonMounted,
  Zi as isBackButtonSupported,
  Ki as isBackButtonVisible,
  mu as isBiometryAvailable,
  Su as isBiometryMounted,
  wu as isBiometryMounting,
  _u as isBiometrySupported,
  Pf as isCSSVarsBoundError,
  _f as isCancelledError,
  Em as isCheckingHomeScreenStatus,
  Us as isClosingBehaviorMounted,
  Lu as isClosingConfirmationEnabled,
  Yu as isCloudStorageSupported,
  Mo as isColorDark,
  jf as isConcurrentCallError,
  Ca as isFullscreen,
  Nf as isFullscreenFailedError,
  Of as isFunctionNotAvailableError,
  nc as isHapticFeedbackSupported,
  If as isInvalidArguments,
  Bf as isInvalidEnvError,
  $f as isInvalidLaunchParamsError,
  Ac as isInvoiceOpened,
  vc as isInvoiceSupported,
  Cf as isInvokeCustomMethodError,
  Ef as isLaunchParamsRetrieveError,
  Tc as isLocationManagerAccessGranted,
  Bc as isLocationManagerAccessRequested,
  xc as isLocationManagerAvailable,
  Fc as isLocationManagerMounted,
  Lc as isLocationManagerMounting,
  Pc as isLocationManagerSupported,
  xl as isMainButtonEnabled,
  Tl as isMainButtonLoaderVisible,
  To as isMainButtonMounted,
  Bl as isMainButtonVisible,
  wf as isMethodMethodParameterUnsupportedError,
  vf as isMethodUnsupportedError,
  sp as isMiniAppActive,
  np as isMiniAppCssVarsBound,
  rp as isMiniAppDark,
  _p as isMiniAppMounted,
  fp as isMiniAppMounting,
  op as isMiniAppSupported,
  xf as isNotAvailableError,
  $p as isPopupOpened,
  Ap as isPopupShown,
  vp as isPopupSupported,
  Np as isQrScannerOpened,
  Bp as isQrScannerSupported,
  we as isRGB,
  cl as isRGBShort,
  qu as isRequestingBiometryAccess,
  Tm as isRequestingContact,
  cm as isRequestingEmojiStatusAccess,
  Qc as isRequestingLocation,
  Am as isRequestingPhoneAccess,
  jm as isRequestingWriteAccess,
  kr as isSSR,
  Hp as isSecondaryButtonEnabled,
  Fp as isSecondaryButtonLoaderVisible,
  ta as isSecondaryButtonMounted,
  Jp as isSecondaryButtonSupported,
  Wp as isSecondaryButtonVisible,
  qf as isSetEmojiStatusError,
  fm as isSettingEmojiStatus,
  nd as isSettingsButtonMounted,
  rd as isSettingsButtonSupported,
  td as isSettingsButtonVisible,
  Vf as isShareMessageError,
  ld as isSwipeBehaviorMounted,
  pd as isSwipeBehaviorSupported,
  $r as isTMA,
  hl as isThemeParamsCssVarsBound,
  wl as isThemeParamsDark,
  Yl as isThemeParamsMounted,
  Ql as isThemeParamsMounting,
  bf as isTimeoutError,
  Sf as isUnknownEnvError,
  dd as isVerticalSwipesEnabled,
  Bd as isViewportCssVarsBound,
  yd as isViewportExpanded,
  Pd as isViewportMounted,
  Ad as isViewportMounting,
  gd as isViewportStable,
  Qf as locationManager,
  Rc as locationManagerMountError,
  Vc as locationManagerMountPromise,
  Zf as mainButton,
  Ml as mainButtonBackgroundColor,
  Pl as mainButtonHasShineEffect,
  Rn as mainButtonState,
  Ol as mainButtonText,
  Il as mainButtonTextColor,
  Xf as miniApp,
  Xl as miniAppBackgroundColor,
  Un as miniAppBackgroundColorRGB,
  ep as miniAppBottomBarColor,
  zn as miniAppBottomBarColorRGB,
  tp as miniAppHeaderColor,
  Vo as miniAppHeaderColorRGB,
  mp as miniAppMountError,
  Uo as miniAppMountPromise,
  bp as miniAppReady,
  Lo as miniAppState,
  kf as mockTelegramEnv,
  eu as mountBackButton,
  vu as mountBiometry,
  Hs as mountBiometryPromise,
  Wu as mountClosingBehavior,
  Nc as mountLocationManager,
  Dl as mountMainButton,
  dp as mountMiniApp,
  Kp as mountSecondaryButton,
  od as mountSettingsButton,
  _d as mountSwipeBehavior,
  qo as mountThemeParams,
  kd as mountViewport,
  B as off,
  _m as offAddToHomeScreenFailed,
  ym as offAddedToHomeScreen,
  nu as offBackButtonClick,
  Vl as offMainButtonClick,
  Zp as offSecondaryButtonClick,
  id as offSettingsButtonClick,
  k as on,
  hm as onAddToHomeScreenFailed,
  bm as onAddedToHomeScreen,
  tu as onBackButtonClick,
  Nl as onMainButtonClick,
  Yp as onSecondaryButtonClick,
  ad as onSettingsButtonClick,
  Tu as openBiometrySettings,
  Cc as openInvoice,
  Mc as openInvoiceError,
  kc as openInvoicePromise,
  Sm as openLink,
  Kc as openLocationManagerSettings,
  wp as openPopup,
  Sp as openPopupError,
  Ep as openPopupPromise,
  Dp as openQrScanner,
  Vp as openQrScannerError,
  ea as openQrScannerPromise,
  ef as openTelegramLink,
  Jf as parseInitDataQuery,
  Kf as parseLaunchParamsQuery,
  em as popup,
  _ as postEvent,
  tm as qrScanner,
  Lm as readTextFromClipboard,
  S as request,
  hu as requestBiometry,
  ju as requestBiometryAccess,
  Du as requestBiometryAccessError,
  Ws as requestBiometryAccessPromise,
  Pm as requestContact,
  Bm as requestContactError,
  xm as requestContactPromise,
  Lr as requestContentSafeAreaInsets,
  im as requestEmojiStatusAccess,
  lm as requestEmojiStatusAccessError,
  um as requestEmojiStatusAccessPromise,
  Ld as requestFullscreen,
  Gc as requestLocation,
  Jc as requestLocationError,
  lo as requestLocationPromise,
  af as requestPhoneAccess,
  Mm as requestPhoneAccessError,
  km as requestPhoneAccessPromise,
  Rr as requestSafeAreaInsets,
  wd as requestViewport,
  Om as requestWriteAccess,
  qm as requestWriteAccessError,
  Im as requestWriteAccessPromise,
  _c as restoreInitData,
  bn as retrieveLaunchParams,
  Ii as retrieveRawInitData,
  $s as retrieveRawLaunchParams,
  Um as safeCall,
  nm as secondaryButton,
  Lp as secondaryButtonBackgroundColor,
  Rp as secondaryButtonHasShineEffect,
  Up as secondaryButtonPosition,
  Zn as secondaryButtonState,
  zp as secondaryButtonText,
  Gp as secondaryButtonTextColor,
  Rm as sendData,
  ml as serializeInitDataQuery,
  Yf as serializeLaunchParamsQuery,
  Ao as serializeToQuery,
  ec as setCloudStorageItem,
  Mf as setDebug,
  pm as setEmojiStatus,
  mm as setEmojiStatusError,
  dm as setEmojiStatusPromise,
  Ll as setMainButtonParams,
  zo as setMiniAppBackgroundColor,
  Go as setMiniAppBottomBarColor,
  Qo as setMiniAppHeaderColor,
  Xp as setSecondaryButtonParams,
  rm as settingsButton,
  Hm as shareMessage,
  Fm as shareStory,
  Cm as shareURL,
  ru as showBackButton,
  Cp as showPopup,
  Mp as showPopupError,
  kp as showPopupPromise,
  ud as showSettingsButton,
  de as supports,
  sm as swipeBehavior,
  Wm as switchInlineQuery,
  Oi as targetOrigin,
  om as themeParams,
  bl as themeParamsAccentTextColor,
  pt as themeParamsBackgroundColor,
  xo as themeParamsBottomBarBgColor,
  Ln as themeParamsButtonColor,
  Po as themeParamsButtonTextColor,
  yl as themeParamsDestructiveTextColor,
  gl as themeParamsHeaderBackgroundColor,
  vl as themeParamsHintColor,
  El as themeParamsLinkColor,
  Jl as themeParamsMountError,
  Do as themeParamsMountPromise,
  Je as themeParamsSecondaryBackgroundColor,
  $l as themeParamsSectionBackgroundColor,
  Sl as themeParamsSectionHeaderTextColor,
  Cl as themeParamsSectionSeparatorColor,
  _l as themeParamsState,
  kl as themeParamsSubtitleTextColor,
  Al as themeParamsTextColor,
  ll as toRGB,
  So as transformQueryUsing,
  su as unmountBackButton,
  Nu as unmountBiometry,
  Uu as unmountClosingBehavior,
  Yc as unmountLocationManager,
  Rl as unmountMainButton,
  yp as unmountMiniApp,
  ed as unmountSecondaryButton,
  cd as unmountSettingsButton,
  bd as unmountSwipeBehavior,
  Zl as unmountThemeParams,
  xd as unmountViewport,
  Vu as updateBiometryToken,
  am as viewport,
  ca as viewportContentSafeAreaInsetBottom,
  la as viewportContentSafeAreaInsetLeft,
  pa as viewportContentSafeAreaInsetRight,
  da as viewportContentSafeAreaInsetTop,
  cr as viewportContentSafeAreaInsets,
  ir as viewportHeight,
  Md as viewportMountError,
  $a as viewportMountPromise,
  fa as viewportSafeAreaInsetBottom,
  ma as viewportSafeAreaInsetLeft,
  ha as viewportSafeAreaInsetRight,
  _a as viewportSafeAreaInsetTop,
  lr as viewportSafeAreaInsets,
  ur as viewportStableHeight,
  ia as viewportState,
  ua as viewportWidth,
  C as wrapSafe
};
//# sourceMappingURL=index.js.map
